import React, { Component } from 'react';
import {
    GanttComponent,
    EditDialogFieldsDirective,
    DayMarkers,
    EditDialogFieldDirective,
    Inject,
    Edit,
    Selection,
    Toolbar,
    ColumnsDirective,
    ColumnDirective,
    CriticalPath,
    ContextMenu,
    Reorder,
    Resize,
    VirtualScroll,
    Filter,
    IGanttData,
    ColumnMenu,
    PdfExport,
    Sort,
    ExcelExport,
    TimelineSettingsModel, FilterType,
} from '@syncfusion/ej2-react-gantt';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import MassiveOrderEdit from '../../utils/MassOrderEdit';
import {
    DropDownListComponent,
    MultiSelectComponent,
    MultiSelectComponent as MultiSelectC
} from '@syncfusion/ej2-react-dropdowns';
import { all_information, loadingShow, GetBackendUrlForGlobalFunctions } from '../../App';
import Message from '../../utils/Message/Message';
import moment from 'moment';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import {
    ColumnChooser,
    FilterSettingsModel,
    ContextMenuItemModel, Column,
} from '@syncfusion/ej2-react-grids';
import Load from './Load';
import { ThemeContext } from '../../context/theme.context';
import { ItemModel, SidebarComponent } from '@syncfusion/ej2-react-navigations';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import {
    ButtonPropsModel,
    DialogComponent, TooltipComponent,
} from '@syncfusion/ej2-react-popups';
import {
    NumericTextBoxComponent,
    TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import {
    ButtonComponent,
    ChipDirective,
    ChipListComponent,
    ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import { FcSettings } from 'react-icons/fc';
import { AiFillLock, AiFillUnlock, AiOutlineFilter } from 'react-icons/ai';
import {
    DateRangePickerComponent,
    DateTimePickerComponent,
} from '@syncfusion/ej2-react-calendars';
import {
    GetGanttSettings,
    GetMaxProntoRowIdData,
} from '../../services/CloudScheduler/CloudSchedulerServices';
import {
    EditOperations,
    updateDependency,
} from '../../services/Operations/OperationServices';
import { EditPlan, getPlan } from '../../services/ControlCenter/PlanServices';
import axios, { AxiosResponse } from 'axios';
import { getEvents } from '../../services/events/event';
import { editDialogFields, schedulerColumns } from './columns';
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import GlobalPlannedOrderGrid from '../../components/GlobalPlannedOrderGrid';
import {
    EditMassOrder,
    GetGanttDataByPlan,
    SavePointOfTheGantt,
    SendRequest,
} from '../../utils/CreateRequest';
import { GetRosters } from '../../services/Settings/Roster';
import { arrayPreparing, generateSegmentation } from '../../utils/GanttHelper';
import { addToQuery, applyTheRule } from '../../utils/BussinesRuleBuilder';
import SidebarKPI from './SidebarKPI';
import GanttSettings from './GanttSettings';
import GlobalDialog from '../../components/GlobalDialog';
import {
    GlobalDropDown,
    GlobalMultiSelection,
} from '../../components/GlobalDropDown';
import { connect, useDispatch } from 'react-redux';
import {
    setAssignments,
    setCloudSchedularGantDataChanged,
    setCloudSchedulerFilterTeamDropdownValueChanged,
    setDefaultPairTrades,
    setDefaultTeams,
    setIsPlanSelected,
    setRefreshTeamComponent,
    setSearchCaseOrder,
    setStoreTeam,
    setTeamDataChanged,
    setTrades,
} from '../../redux/search.slice';
import GlobalSearch from '../../components/GlobalSearch';
import {
    convertToDate,
    extractCharacters,
    extractNumbers,
    extractStringValue, getAdjustedDatas, getLocalUtcOffSetValue, groupTasksByDate, parseDependencyCode,
    SavePointEdit, transformToMultiTableFormat,
} from '../../utils/Methods/methods';
import { RootState, store } from '../../store';
import { getPriority } from '../../utils/GetPriorityColor';
import { ColumnsType, DependencyInfo, UpdateDependencyType } from '../../utils/Types/types'
import { EditProntoOrders } from '../../services/ProntoServices/WorkOrderService/WorkOrderService';
import { GetTablenameFromTask } from '../../utils/GetTablenameFromTask';
import { io } from 'socket.io-client';
import { FetchNewMexRecordsOperations } from '../../services/MexServices/Orders/OrderService';

const GetErpTypeFromConfig = () => {
    const state = store.getState();
    const erpType = state.search.erpType;
    return erpType;
};
const ERP_TYPE = GetErpTypeFromConfig();
const erpTypeName = 'MEX';
var searchText: string = '';

interface IProps {
    setCloudSchedulerFilterTeamDropdownValueChanged: (value: boolean) => void;
    isSuperVisor?: boolean;
    toolbar?: any;
    dispatch?: any;
    isOpPlanSelected?: boolean;
    planId?: number;
    setSearchCaseOrder: (value: string) => void;
    searchCaseOrder: string;
    timezone_offset: number;
    page_range_from_settings: number;
    weekStartDay: number;
    current_plan_data: any;
    current_plan_id: number;
    schedulerFetchRequest: boolean;
}

interface IState {
    selectedRecords: Array<any>;
    isEditingOrder: boolean;
    displayGantInformation: boolean;
    massiveEditDialog: boolean;
    questionDialog: boolean;
    defaultConfirmScheduleDate: Date | undefined;
    GantData: any;
    resourceData: any;
    status: boolean;
    loadGant: Array<any>;
    projectStartDate: Date;
    projectEndDate: Date;
    isSidebarOpen: boolean;
    hideDeleteDialog: boolean;
    hideAssignTeamDialog: boolean;
    hidePercentage: boolean;
    hideSchedulerTimeDialog: boolean;
    settingsDialog: boolean;
    ShiftElementData: Array<any>;
    hideFilterDialog: boolean;
    trades_data: Array<any>;
    tradesValues: any;
    dayWorkingTime: Array<any>;
    current_plan_isLocked: boolean;
    currentDialogSettings: {
        width: string | undefined;
        height: string | undefined;
        firstButtonText: string | undefined;
        seccondButtonText: string | undefined;
        type: string | undefined;
        content: any | undefined;
        show: boolean | undefined;
    };
    maxSchedulerPeriod: number;
    hideDialogOrder: boolean;
    allowDragDrop: boolean;
    allowSeg: boolean;
    query: string;
    refreshToken: string;
    referenceFMSComValue: string;
    loadSignal: boolean;
    current_query: string;
    priorityColorData: any[];
    allowBatchArray: boolean;
}

let selectedChips: Array<any> = [];
let chips: ChipListComponent = new ChipListComponent({});

export class CloudScheduler extends Component<IProps, IState> {
    static contextType = ThemeContext;
    context!: React.ContextType<typeof ThemeContext>;
    private ganttDatas: any;
    private allowEdit: boolean = false;
    private socket = io(GetBackendUrlForGlobalFunctions() as string, {
        autoConnect: false,
        transports: ['websocket'],
    });
    private readonly server_gmt: number | null = 11;
    private readonly serverOffsetMillis: number = 0;
    private readonly localOffset: number = 0;
    private readonly localOffsetMillis: number = 0;

    private moment = require('moment-timezone');
    private editSettings: object = {
        allowAdding: true,
        allowEditing: true,
        allowDeleting: true,
        allowTaskbarEditing: true,
        showDeleteConfirmDialog: true,
        mode: 'Auto',
    };

    private assignTeamDropDown: DropDownListComponent = new DropDownListComponent(
        {}
    );
    private assignTeamText: string = '';


    private condition: boolean = true;
    private dropDown: DropDownListComponent;
    private batch_obj: Array<any> = [];
    public static start_date: Date =
        localStorage.getItem('load_start_date') !== null
            ? new Date(localStorage.getItem('load_start_date') as string)
            : new Date();
    private expandedOrders: IGanttData[] = [];
    public editDialogFields: any = [
        { type: 'General' },
        { type: 'Predecessor' },
        { type: 'Resources' },
        { type: 'Notes' },
        {
            type: 'Custom',
            headerText: 'Extra Tab',
            fields: ['ExtraCol1', 'ExtraCol2'],
        },
    ];
    // { field: 'WorkOrderDescription', headerText: '#', width: 300 },
    // { field: 'StartDate', headerText: 'Sched. Date', width: 150 },
    // { field: 'TaskID', headerText: 'ID', width: 100 },
    // { field: 'TaskName', headerText: 'Operation Name', width: 400 },
    // { field: 'tradeCode', headerText: 'Trade', width: 120 },
    // { field: 'Duration', headerText: 'Duration (h)', width: 120 },
    // { field: 'EndDate', headerText: 'End Date', width: 150 }
    private excelExportsColumns: any = [
        { field: 'WorkOrderDescription', headerText: '', width: 300 },
        { field: 'StartDate', headerText: 'Sched. Date', width: 100 },
        { field: 'asset_code', headerText: 'Plant Item', width: 80 },
        { field: 'asset_description', headerText: 'Plant Description', width: 100 },
        { field: 'orderCode', headerText: 'W/O #', width: 80 },
        { field: 'TaskName', headerText: 'Work Order Description', width: 400 },
        { field: 'pm_schedule_id', headerText: 'PM Task', width: 80 },
        { field: 'type_code', headerText: 'Type', width: 80 },
        { field: 'site_details_1', headerText: 'Reference', width: 80 },
        { field: 'reason', headerText: 'Hold Reason', width: 80 },
        { field: 'order_resp_code', headerText: 'Resp', width: 80 },
        { field: 'priority_code', headerText: 'Priority', width: 80 },
        { field: 'teamCode', headerText: 'uWork Team', width: 80 },
        { field: 'shift', headerText: 'uWork Shift', width: 80 },
        { field: 'tradeCode', headerText: 'Lab.', width: 80 },
        { field: 'required', headerText: 'Qty.', width: 80 },
        { field: 'estHours', headerText: 'Hrs', width: 80 },
        { field: 'section', headerText: 'Section', width: 80 },
        { field: 'plannedBy', headerText: 'Plan By', width: 80 },

        { field: 'plannedBy', headerText: 'Cost Act.', width: 80 },
        { field: 'plannedBy', headerText: 'Cost Bud.', width: 80 },
        { field: 'plannedBy', headerText: 'Technician', width: 80 },
        { field: 'plannedBy', headerText: 'Permit', width: 80 },
        { field: 'plannedBy', headerText: 'High Risk Work', width: 80 },
        { field: 'plannedBy', headerText: 'RSCHD Date', width: 80 },
        { field: 'plannedBy', headerText: 'RSCHD Code', width: 80 },
    ];
    private current_data: Array<any> = [];
    private percentage: NumericTextBoxComponent = new NumericTextBoxComponent({});
    private isMountedCS: boolean = false;
    private reasonCodes: DropDownListComponent = new DropDownListComponent({});
    private percentageNumber: NumericTextBoxComponent =
        new NumericTextBoxComponent({});
    private reasonDesc: any = new TextBoxComponent({});
    private offset = localStorage.getItem('offsetValue');
    temp = (props: any) => {
        return (
            <div>
                <NumericTextBoxComponent
                    width={120}
                    value={this.offset ? parseInt(this.offset) : 1}
                    min={1}
                    max={365}
                    step={1}
                    onChange={(args: any) => {
                        this.offset = args.value;
                        localStorage.setItem('offsetValue', `${args.value}`);
                    }}
                    //placeholder='Percentage format'
                    floatLabelType='Auto'
                />
            </div>
        );
    };

    private theQueryScheduleNumber = '';
    private theQueryStatuses = '';
    private theQueryPrioritys = '';
    private theQueryDepartment = '';
    private theQuerySection = '';
    private theQueryProntoReference = '';
    private theQueryHoldReason = '';
    private theQueryAsset = '';
    private theQueryOutterAsset = '';
    private theQueryType = '';
    private theQueryHasProblem = '';
    private theQueryResp = '';
    private theQueryDate = '';
    private theQuerySearch = '';
    private theQueryWorkOrderCode = '';
    private theQueryReference = '';
    private isAgentAlive: boolean = false;
    private priorityFMSComValue: Array<any> = [];
    private departmentFMSComValue: Array<any> = [];
    private sectionFMSComValue: Array<any> = [];
    private prontoReferenceFMSComValue: Array<any> = [];
    private holdReasonFMSComValue: Array<any> = [];
    private statusFMSComValue: Array<any> = [];
    private typeFMSComValue: Array<any> = [];
    private hasProblemValue: Array<any> = [];

    private respFMSComValue: Array<any> = [];

    private workorderCodeFMSComValue: string = '';
    private ScheduleNumberFMSComValue: string = '';
    private assetFMSComValue: string = '';
    private statusFMSCom: MultiSelectC = new MultiSelectC({});
    private schdeduleStartDateVal: any = '';
    private departmentFMSCom: MultiSelectC = new MultiSelectC({});
    private sectionFMSCom: MultiSelectC = new MultiSelectC({});
    private prontoReferenceFMSCom: MultiSelectC = new MultiSelectC({});
    private holdReasonFMSCom: MultiSelectC = new MultiSelectC({});
    private typeFMSCom: MultiSelectC = new MultiSelectC({});
    private hasProblem: MultiSelectC = new MultiSelectC({});
    private respFMSCom: MultiSelectC = new MultiSelectC({});
    private startDateFMSCom: any = null;
    private priorityFMSCom: MultiSelectC = new MultiSelectC({});
    private assetFMSCom: TextBoxComponent = new TextBoxComponent({});
    private referenceFMSCom: TextBoxComponent = new TextBoxComponent({});
    private workorderCodeFMSCom: TextBoxComponent = new TextBoxComponent({});
    private ScheduleNumberFMSCom: TextBoxComponent = new TextBoxComponent({});
    private checkFilterParams = true;
    private reduxSearchS = this.props;

    private toolbarAdmin: (string | ItemModel)[] = [
        {
            text: 'Assign Workorders',
            tooltipText: 'Assign workorders into the plan.',
            prefixIcon: 'e-properties-1',
            id: 'assign_workorders',
        },
        {
            text: 'Send Back',
            tooltipText: '.',
            prefixIcon: 'e-send-to-back',
            id: 'reject',
        },
        {
            text: 'Previous Day',
            tooltipText: 'Rescheduled it for one day.',
            prefixIcon: 'e-chevron-left',
            id: 'previous',
        },
        {
            text: 'Next Day',
            tooltipText: 'Rescheduled it for one day.',
            prefixIcon: 'e-chevron-right',
            id: 'next',
        },
        {
            text: 'Show History',
            tooltipText: 'Show history of the record.',
            prefixIcon: 'e-notes',
            id: 'history',
        },
        'Edit',
        'Update',
        {
            text: 'Assign Shift',
            tooltipText: 'Assign Shift',
            prefixIcon: 'e-day',
            id: 'assignshift',
        },
        {
            text: 'Assign Team',
            tooltipText: 'Assign Team',
            prefixIcon: 'e-people',
            id: 'assignteam',
        },
        {
            text: 'Percentage',
            tooltipText: 'To set percentage on a record',
            prefixIcon: 'e-edit',
            id: 'percentage',
        },
        {
            text: 'Schedule',
            tooltipText: 'Scheduler',
            prefixIcon: 'e-timeline-month',
            id: 'scheduler',
        },
        {
            text: 'Refresh',
            tooltipText: 'Refresh',
            prefixIcon: 'e-repeat',
            id: 'refresh',
        },
        'Cancel',
        'ExpandAll',
        'CollapseAll',
        'Indent',
        'Outdent',
        'Search',
        'PrevTimeSpan',
        'NextTimeSpan',
        'Outdent',
        'Indent',
        'ZoomIn',
        'ZoomOut',
        'ZoomToFit',
        'CsvExport',
        'PdfExport',
        'ExcelExport',
        'CriticalPath',
    ];
    priorityColorTemplate = (args?: any) => {
        let color = this.state.priorityColorData.find(
            (x: any) => x.priority_code?.trim() === args.priority_code?.trim()
        )?.priority_color;

        return args?.operationSequence == null ? (
            <div
                style={{
                    backgroundColor: color,
                    borderRadius: 7,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '50px',
                    height: '20px',
                }}
            >
                <span style={{ color: 'white' }}>{args.priority_code}</span>
            </div>
        ) : null;
    };
    assetCodeTemplate = (args?: any) => {
        return args?.operationSequence == null ? (
            <p
                style={{
                    display: 'contents',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}
            >
                {' '}
                {args.asset_code}{' '}
            </p>
        ) : null;
    };

    modifyColumns = (List: ColumnsType[]): Object[] => {
        // List.push({ template: priorityColorChip.bind(this), align: 'Right' });
        var LastList = List.map((eachColumn) => {
            if (eachColumn.field === 'priority_code') {
                return {
                    ...eachColumn,
                    template: this.priorityColorTemplate,
                };
            }
            if (eachColumn.field === 'asset_code') {
                return {
                    ...eachColumn,
                    template: this.assetCodeTemplate,
                };
            }
            return eachColumn;
        });

        return LastList;
    };

    private changesAppliedColumns: ColumnsType[] =
        this.modifyColumns(schedulerColumns);
    searchText = this.reduxSearchS.searchCaseOrder;

    private current_query: string = '';
    private theQueryPlanId: string = '';
    private theQueryIsEffected: string = '';
    private allowToFire: boolean = true;
    private theCurrentEl: any = [];
    private answer: boolean = false;

    private timezone_offset = -1 * this.props.timezone_offset;
    private source = axios.CancelToken.source();

    private buttonsOrder: ButtonPropsModel[] = [
        {
            buttonModel: { content: 'All Data' },
            click: () => {
                this.answer = true;
                loadingShow(true, 'Waiting for fetch operations...');

                FetchNewMexRecordsOperations(this.timezone_offset)
                    .then((result: any) => {
                        if (!this.isMountedCS) return;
                        if (result.status == 200) {
                            loadingShow(false);
                            if (result.data.length === 0) {
                                Message.success('There is no new record...');
                                this.buildQuery();
                            } else {
                                Message.success(`Fetched records successfully...`);
                                this.buildQuery();
                            }
                        }
                    })
                    .catch((err) => {
                        if (!this.isMountedCS) return;
                        loadingShow(false);
                        Message.error('Fetching failed!!!');
                    });
                this.setState({
                    questionDialog: false,
                });
            },
        },
        {
            buttonModel: { content: 'Planned Data' },
            click: () => {
                this.answer = false;
                let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
                if (thePlanID === 0) {
                    Message.error('Please select a plan...');
                } else {
                    loadingShow(true, 'Waiting for fetch operations...');
                    FetchNewMexRecordsOperations(this.timezone_offset, thePlanID)
                        .then((result: any) => {
                            if (result.status == 200) {
                                loadingShow(false);
                                if (result.data.length === 0) {
                                    Message.success('There is no new record...');
                                    this.buildQuery();
                                } else {
                                    Message.success(`Fetched records successfully...`);
                                    this.buildQuery();
                                }
                            }
                        })
                        .catch((err) => {
                            loadingShow(false);
                            Message.error('Fetching failed!!!');
                        });
                    this.setState({
                        questionDialog: false,
                    });
                }
            },
        },
    ];

    private buttonShiftAssignment: ButtonPropsModel[] = [
        {
            click: () => {
                this.shiftAssignment();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                this.setState({ hideDeleteDialog: false });
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    private buttonTeamAssignment: ButtonPropsModel[] = [
        {
            click: () => {
                this.teamAssignment();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                this.setState({ hideAssignTeamDialog: false });
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    private buttonPercentage: ButtonPropsModel[] = [
        {
            click: () => {
                this.setPercentage();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                this.setState({ hidePercentage: false });
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    private buttonScheduler: ButtonPropsModel[] = [
        {
            click: (args: any) => {
                this.schedulerGanttRecords();
            },
            buttonModel: {
                content: 'Yes',
                isPrimary: true,
            },
        },
        {
            click: () => {
                this.setState({ hideSchedulerTimeDialog: false });
            },
            buttonModel: {
                content: 'No',
                isPrimary: false,
            },
        },
    ];
    private gantObj: GanttComponent = new GanttComponent({});
    private sidebarobj: SidebarComponent = new SidebarComponent({});
    private dropDownListObjectShiftElment: DropDownListComponent =
        new DropDownListComponent({});
    private multiselectObj: MultiSelectComponent = new MultiSelectComponent({});
    private dateTimePicker: DateTimePickerComponent = new DateTimePickerComponent(
        {}
    );

    private resourceFields: object = {
        id: 'resourceId',
        name: 'resourceName',
    };
    private timelineSettings: TimelineSettingsModel = {
        weekStartDay: this.props.weekStartDay,
        updateTimescaleView: false,
        timelineUnitSize: 60,
        topTier: {
            format: 'MMM dd, yyyy',
            unit: 'Day',
            count: 7,
        },
        bottomTier: {
            unit: 'Hour',
            format: 'EEE, dd',
            count: 24,
        },
    };
    private labelSettings: object = {
        leftLabel: 'TaskName',
        rightLabel: 'Resources',
        taskLabel: '${Progress}%',
    };

    constructor(props: IProps) {
        super(props);
        this.dropDown = new DropDownListComponent(props);
        const state = store.getState();
        let gmt = 11;
        // let drawerOffsetValue = getLocalUtcOffSetValue();
        // if(!isNaN(drawerOffsetValue)) {
        //     gmt = drawerOffsetValue / -60;
        // }
        this.server_gmt = gmt;
        this.localOffset = new Date().getTimezoneOffset();
        this.localOffsetMillis = 60 * 1000 * this.localOffset;

        this.serverOffsetMillis = this.server_gmt != null
            ? 60 * 1000 * -(this.server_gmt * 60)
            : 60 * 1000 * -(11 * 60);

        this.state = {
            selectedRecords: [],
            isEditingOrder: false,
            displayGantInformation: false,
            massiveEditDialog: false,
            questionDialog: false,
            defaultConfirmScheduleDate: undefined,
            resourceData: [],
            status: false,
            loadGant: [],
            GantData: [],
            projectStartDate: new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1,
                gmt
            ),
            projectEndDate: new Date(
                new Date().getFullYear(),
                new Date().getMonth() + 1,
                0,
                gmt
            ),
            isSidebarOpen: false,
            hideDeleteDialog: false,
            hideAssignTeamDialog: false,
            ShiftElementData: [],
            settingsDialog: false,
            hideFilterDialog: false,
            trades_data: [],
            tradesValues: [1, 2, 3, 4, 5],
            dayWorkingTime: [{ from: 0, to: 24 }],
            hideSchedulerTimeDialog: false,
            currentDialogSettings: {
                width: '700px',
                height: 'auto',
                firstButtonText: 'Save',
                seccondButtonText: 'Cancel',
                type: 'exeption',
                content: undefined,
                show: false,
            },
            current_plan_isLocked: false,
            maxSchedulerPeriod: 0,
            hideDialogOrder: false,
            allowDragDrop: false,
            allowSeg: false,
            hidePercentage: false,
            query: '',
            refreshToken: '',
            referenceFMSComValue: '',
            loadSignal: false,
            current_query: '',
            priorityColorData: [],
            allowBatchArray: true
        };
        this.dropDown.width = '70px';
    }

    //Components stuff
    async componentDidMount() {
        this.isMountedCS = true;
        let theData = await getPriority();

        if (this.isMountedCS) {
            this.setState({ priorityColorData: theData });
        } else {
            return;
        }

        this.current_query = await applyTheRule('uw_order', 'Cloud Scheduler');

        if (this.current_query !== '') {
            Message.info(
                'The query is applied from the rule. Consider to remove it from the rules'
            );
        }

        if (!this.isMountedCS) return;
        let theValue = localStorage.getItem('cs-drag-drop-enabled');
        let theValueAllowSeg = localStorage.getItem('cs-allow-seg-enabled');

        if (this.isMountedCS) {
            if (theValue === 'true') {
                this.setState({ allowDragDrop: true });
            } else {
                this.setState({ allowDragDrop: false });
            }
        }
        if (this.isMountedCS) {
            if (theValueAllowSeg === 'true') {
                this.setState({ allowSeg: true });
            } else {
                this.setState({ allowSeg: false });
            }
        }
        this.getShiftElments();
        this.getTradePerson();
        this.getMaxSchedulerSettings('supervisor-control$max-scheduler-period');

        this.socket.on('OnSyncQueryFeedback', (data: any) => {
            this.isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;


            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                this.buildQuery();
                this.context.setLoadAllowChange(true);
                Message.success(theMessage);
            }
        });
        this.socket.on('OnGetNewRecordQueryFeedback', (data: any) => {
            this.isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                this.buildQuery();
                Message.success(theMessage);
            }
        });
        this.socket.on('onSyncOperationQueryFeedback', (data: any) => {
            this.isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });
        this.socket.on('OnResetOperationQueryFeedback', (data: any) => {
            this.isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                Message.success(theMessage);
            }
        });
        this.socket.on('OnResetDataQueryFeedbackCloudSchedular', (data: any) => {
            this.isAgentAlive = true;
            let theData = JSON.parse(data);
            let theMessage = theData.request_sql;
            if (theMessage.includes('failed')) {
                Message.error(theMessage);
            } else {
                this.buildQuery();
                this.context.setLoadAllowChange(true);
                Message.success(theMessage);
            }
        });
        this.socket.connect();
    }
    async componentDidUpdate(prevProps: any, prevState: any) {
        const { schedulerFetchRequest, setSchedulerFetchRequest } = this.context;

        if (!prevState.schedulerFetchRequest && schedulerFetchRequest) {
            this.refreshSchedulerGanttRecords();
            setSchedulerFetchRequest(false);
        }
        const { isClickedQuickLoad, setIsClickedQuickLoad } = this.context;
        const { quickScheduleDateOnLoad } = this.context;
        //if(this.selectedChildList.length > 0){
        if (isClickedQuickLoad && prevState?.isClickedQuickLoad !== isClickedQuickLoad) {
            this.reSchedulerGantt(
                false,
                '',
                quickScheduleDateOnLoad,
                undefined,
                undefined,
                true,
                undefined,
                true,
                'edit-button'
            );
            setIsClickedQuickLoad(false);
        }
        //}
    }
    componentWillUnmount(): void {
        this.isMountedCS = false;
        this.source.cancel();

        if (this.socket) {
            this.socket.removeAllListeners();
            if (this.socket.connected) {
                this.socket.disconnect();
            }
        }
    }

    //Gantt Settings
    private contextMenuOpen(args: any): void {
        let record: IGanttData = args.rowData;
        if (args.type !== 'Header') {
            if (!record?.hasChildRecords) {
                args.hideItems.push('Collapse the Row');
                args.hideItems.push('Expand the Row');
            } else {
                if (record?.expanded) {
                    args.hideItems.push('Expand the Row');
                } else {
                    args.hideItems.push('Collapse the Row');
                }
            }
        }
    }

    private ScheduleDropdownItems = [
        {
            text: 'Show History',
            tooltipText: 'Show history of the record.',
            prefixIcon: 'e-notes',
            id: 'history',
        },
        {
            text: 'Percentage',
            tooltipText: 'To set percentage on a record',
            prefixIcon: 'e-edit',
            id: 'percentage',
        }
        //{
        //     text: 'Schedule',
        //     tooltipText: 'Scheduler',
        //     prefixIcon: 'e-timeline-month',
        //     id: 'scheduler',
        // },
    ];

    private dropdownTemplate() {
        return (
            <DropDownButtonComponent
                items={this.ScheduleDropdownItems}
                select={this.toolbarClick.bind(this)}
            >
                History & Percentage
            </DropDownButtonComponent>
        );
    }

    private expandeCollapseItems = [
        { text: 'Expand All', id: 'ExpandAll' },
        { text: 'Collapse All', id: 'CollapseAll' },
    ];

    private expandeCollapse() {
        return (
            <DropDownButtonComponent
                items={this.expandeCollapseItems}
                select={this.toolbarClick.bind(this)}
            >
                Expande/Collapse
            </DropDownButtonComponent>
        );
    }

    private zoomToFitItems = [
        { text: 'Zoom In', id: 'ZoomIn' },
        { text: 'Zoom Out', id: 'ZoomOut' },
        { text: 'Show Gant Details', id: 'gantDetails' },
    ];

    private zoomSettings() {
        return (
            <DropDownButtonComponent
                items={this.zoomToFitItems}
                select={this.toolbarClick.bind(this)}
            >
                Zoom
            </DropDownButtonComponent>
        );
    }

    private exportItems = [
        { text: 'Csv Export', id: 'CsvExport' },
        { text: 'Pdf Export', id: 'PdfExport' },
        { text: 'Excel Export', id: 'ExcelExport' },
    ];

    private exports() {
        return (
            <DropDownButtonComponent
                items={this.exportItems}
                select={this.toolbarClick.bind(this)}
            >
                Exports
            </DropDownButtonComponent>
        );
    }

    restoreExpandedRows = () => {
        if (!this.gantObj) {
            return;
        }

        if (!Array.isArray(this.expandedOrders)) {
            return;
        }

        var numberlist: number[] = [];
        // const numberlist: number[] = [];

        (this.expandedOrders || []).forEach((item: any) => {
            if (Array.isArray(item)) {
                item.forEach((row: any) => {
                    if (typeof row.index === 'number') {
                        numberlist.push(row.index);
                    }
                });
            } else if (typeof item.index === 'number') {
                numberlist.push(item.index);
            }
        });

        this.expandedOrders = [];

        setTimeout(() => {
            numberlist.forEach((index) => {
                if (this.gantObj && this.gantObj.flatData[index]) {
                    this.gantObj.expandByIndex(index);
                }
            });
        }, 100);

    };

    private contextMenuClick(args: any): void {
        let record: any = args.rowData as any;
        if (args.item.id === 'collapserow') {
            this.gantObj.collapseByID(Number(record.ganttProperties.taskId));
        }
        if (args.item.id === 'expandrow') {
            this.gantObj.expandByID(Number(record.ganttProperties.taskId));
        }
    }

    timeLineChangeFunction(args: any) {
        if (args.value === 2) {
            this.gantObj.timelineSettings = {
                topTier: {
                    unit: 'Day',
                    format: 'MMM dd, yyyy',
                },
                bottomTier: {
                    unit: 'Hour',
                },
                timelineUnitSize: 10,
            };
            this.gantObj?.refresh();
        } else {
            this.gantObj.timelineSettings = {
                topTier: {
                    format: 'MMM dd, yyyy',
                    unit: 'Week',
                },
                bottomTier: {
                    unit: 'Hour',
                },
                timelineUnitSize: 10,
            };
            this.gantObj?.refresh();
        }
    }
    beforePdfExport(args: any) {
        args.isFitToWidth = true;
    }
    private gantCellQuery = (args: any) => {
        if (args.data.childRecords.length == 0) {
            args.cell.setAttribute(
                'style',
                `color:	#D3D3D3DD;font-family: Tahoma, "Trebuchet MS", sans-serif; font-size: 12px;`
            );
        } else {
            args.cell.setAttribute(
                'style',
                `font-family: Tahoma, "Trebuchet MS", sans-serif; font-size: 12px;`
            );
        }

        if (
            args.column &&
            args.column.field === 'isChecked' &&
            args.data &&
            args.cell
        ) {
            let theData = args.data.taskData as any;
            if (theData) {
                let isChecked = theData.isRejected;
                let theCurrenColor = 'tranparent';
                if (isChecked) {
                    if (theData.reason) {
                        let theParseReason = theData?.reason?.split('^&&');
                        let theColorEl = theParseReason[0].split('$');
                        if (theColorEl.length > 0) {
                            theCurrenColor = theColorEl[1];
                        }
                    }
                }
                args.cell.setAttribute(
                    'style',
                    `background-color:${theCurrenColor} !important;`
                );
            }
        }
        if (
            args.column &&
            args.column.type === 'checkbox' &&
            args.data &&
            args.cell
        ) {
            let isEffected = args.data.isEffected;
            let theCurrenColor = 'transparent';
            if (isEffected) {
                theCurrenColor = '#8ECDDD';
            }
            args.cell.setAttribute(
                'style',
                `background-color:${theCurrenColor}!important;`
            );
        }
        // if (
        //     args.column &&
        //     args.column.field === 'operationSequence' &&
        //     args.data &&
        //     args.cell
        // ) {
        //     let operationSequence = args.data.operationSequence;
        //     let theCurrenColor = 'transparent';
        //     if (operationSequence === -999) {
        //         theCurrenColor = '#686868';
        //         args.cell.setAttribute(
        //             'style',
        //             `background-color:${theCurrenColor}!important;`
        //         );
        //     }
        // }
        if (args.data.level === 0) {
            args.cell.classList.add('gantt-row-level-0');
            if (
                args.column.field === 'required' &&
                args.data.childRecords.length > 0
            ) {
                args.cell.innerHTML = Number(
                    args.data.childRecords.reduce(
                        (a: any, b: any) => Number(a) + Number(b.required),
                        0
                    )
                ).toFixed(2);
            }
        }
    };

    getTradePerson() {
        if (!this.isMountedCS) return;
        axios
            .get(GetBackendUrlForGlobalFunctions() + `assignment`)
            .then((res: any) => {

                const transformedData = res.data?.map((el: any) => {
                    return {
                        resourceName: el.alias_name,
                        resourceId: el.assignment_id,
                    };
                }) || [];

                if (this.isMountedCS) {
                    this.setState({
                        resourceData: transformedData,
                    });
                }
            });
    }

    private getMaxSchedulerSettings(query: string) {
        if (!this.isMountedCS) return;
        GetGanttSettings(query).then((res) => {
            if (this.isMountedCS) {
                if (res.data[0]) {
                    let value = res.data[0]?.value;
                    if (!isNaN(value)) {
                        this.setState({ maxSchedulerPeriod: value });
                    }
                }
            }
        });
    }

    async getPlanOrderGant(cond: string) {
        let id = this.props.isSuperVisor ? `${cond}$true` : cond;
        //loadingShow(true, 'Loading');

        try {
            const theData = await GetGanttDataByPlan(id);
            this.ganttDatas = theData;

            if (
                theData.length === 1 &&
                theData[0].order_id === null &&
                theData[0].order_code === null
            ) {
                Message.info('No data to show.');
                return;
            }

            const model = theData
                .filter(res => res.order_id !== null && res.order_code !== null)
                .map(res => {
                    const subtasks = res.subtasks?.map((sub: any) => {
                        return {
                            ...sub,
                            isRejected: res.isRejected,
                            Duration: sub.duration,
                            Progress: sub.percentage,
                            Segments: sub.Segments || [],
                            isDone: res.isDone,
                            StartDate: sub.scheduled_start_date,
                            EndDate: sub.scheduled_end_date,
                            TaskID: sub.operationId,
                            Work: Number(sub.estHours),
                            TaskName: `${sub.operationSequence} - ${sub.operationDescription}`,
                            info: sub.longDescription,
                            Predecessor: sub.dependencyCode,
                            long_description: `<${sub.tradeCode}> ${res.description}`,
                            asset_code: sub.assetCode,
                            type_code: res.type_code,
                            priority_code: sub.priority,
                            isChecked: false,
                            isEffected: res.isEffected,
                            dependentTaskId: sub.dependentTaskId,
                            uniqueDependencyCode: sub.uniqueDependencyCode,
                            order_resp_code: res.order_resp_code,
                            site_details_1: res.site_details_1,
                            reason: res.reason,
                            pm_schedule_id: res.pm_schedule_id,
                            wo_status_code: res.wo_status_code,
                        };
                    }) || [];

                    return {
                        ...res,
                        EndDate: res.planned_end_date,
                        StartDate: res.planned_start_date,
                        TaskID: res.order_id,
                        TaskName: `${res.order_code} - ${res.description}`,
                        isChecked: false,
                        isEffected: res.isEffected,
                        subtasks,
                    };
                });

            if (this.isMountedCS) {
                this.gantObj.dataSource = model;
                this.gantObj.dataBind();
            }
        } catch (error) {
            Message.error('An error occurred while loading the data.');
        } finally {
            loadingShow(false);
        }
    }


    expanded = (args: any) => {
        var expendadOrderDataAlreadyInList = false;
        this.expandedOrders.map((eachExpanded) => {
            if (eachExpanded.uniqueID === args.data.uniqueID) {
                expendadOrderDataAlreadyInList = true;
            }
        });
        if (!expendadOrderDataAlreadyInList) {
            this.expandedOrders.push(args.data);
        }
    };
    collapsed = (args: any) => {
        this.expandedOrders = this.expandedOrders.filter((eachExpanded) => {
            if (eachExpanded.uniqueID !== args.data.uniqueID) {
                return eachExpanded;
            }
        });
    };

    calculateEndDate(
        startDate: string,
        estHours: number | undefined,
        required: number | undefined
    ): string {
        if (!estHours || !required || required === 0) return startDate;

        const hoursPerPerson = parseFloat((estHours / required).toFixed(2));
        let date = new Date(startDate);
        date.setMinutes(date.getMinutes() + hoursPerPerson * 60);

        return date.toISOString();
    }

    calculateDuration(
        estHours: number | undefined,
        required: number | undefined
    ): number {
        if (!estHours || !required || required === 0) return 0;

        return parseFloat((estHours / required).toFixed(2));
    }

    massCallBack = async (args: any, isEditingOrder: boolean) => {
        if (this.gantObj) {
            if (
                this.gantObj.selectionModule?.getSelectedRecords().length > 0 &&
                isEditingOrder
            ) {
                let theDatas = this.gantObj.selectionModule?.getSelectedRecords();
                let theEdittedOp = [];
                theDatas = theDatas.map((each: any) => {
                    return each.taskData;
                });

                loadingShow(true, 'Processing...');
                loadingShow(true, 'Just a second while getting operations....');
                let idList: string[] = [];
                theDatas.map((theData: any) => {
                    idList.push(theData.order_code?.toString());
                });

                //let theOperations = await getOperations('1$100$$', idList);
                // let theOperations = await getOperations('1$100$$'+
                //   theDatas.map((theData: any)=>{
                //     return theData.order_code;
                //   }).toString()
                // );
                loadingShow(true, 'Operations adjusting....');
                // theEdittedOp = theOperations.data.map((theData: any) => {
                //   if (
                //     theData.scheduled_start_date === null ||
                //     theData.scheduled_end_date === null
                //   ) {
                //     theData.scheduled_start_date = args.dataOrder.scheduled_start_date;
                //     theData.scheduled_end_date = args.dataOrder.scheduled_start_date;
                //   } else {
                //     if (args.dataOrder.scheduled_start_date) {
                //       let theDifference = moment(
                //         args.dataOrder.scheduled_start_date
                //       ).diff(new Date(theData.scheduled_start_date), 'millisecond');
                //       theData.scheduled_end_date = moment(theData.scheduled_end_date)
                //         .add(theDifference, 'millisecond')
                //         .toDate();
                //       theData.scheduled_start_date = moment(
                //         args.dataOrder.scheduled_start_date
                //       ).toDate();
                //     }
                //   }
                //   delete theData.material_status;
                //   return { ...theData, ...args.dataOperations };
                // });
                loadingShow(true, 'Orders adjusting....');
                let theCodes = theDatas.map((theData: any) => {
                    if (args.dataOrder.scheduled_start_date) {
                        let theDifference = moment(
                            args.dataOrder.scheduled_start_date
                        ).diff(theData.scheduled_start_date, 'millisecond');
                        theData.scheduled_end_date = moment(
                            theData.scheduled_end_date?.toString()
                        )
                            .add(theDifference, 'millisecond')
                            .toDate();

                        args.dataOrder.scheduled_start_date =
                            args.dataOrder?.scheduled_start_date?.toString();
                    }

                    return { ...theData, ...args.dataOrder, isEffected: true };
                });

                if (ERP_TYPE === 'MEX') {
                    const differenceOffsetMillis = this.serverOffsetMillis - this.localOffsetMillis;

                    theDatas.map((item: any) => {
                        item.scheduled_start_date = new Date(
                            new Date(item.scheduled_start_date)?.getTime() +
                            differenceOffsetMillis
                        ).toString();
                        item.scheduled_end_date = new Date(
                            new Date(item.scheduled_end_date)?.getTime() +
                            differenceOffsetMillis
                        ).toString();
                    });
                }

                var operationsList: Object[] = [];
                var orderlist: Object[] = [];
                theCodes.map((orderAndOperations: any) => {
                    if (orderAndOperations.operationId) {
                        var operationTemp = {
                            required: orderAndOperations.required,
                            estHours: orderAndOperations.estHours,
                            scheduled_end_date: orderAndOperations.scheduled_end_date,
                            longDescription: orderAndOperations.description,
                            operationDescription: orderAndOperations.description,
                            statusCode: orderAndOperations.status_code,
                            workOrderType: orderAndOperations.type_code,
                            section: orderAndOperations.order_section_code,
                            responsibility: orderAndOperations.order_resp_code,
                            priority: orderAndOperations.priority_code,
                            scheduled_start_date: orderAndOperations.scheduled_start_date,
                            operationId: orderAndOperations.operationId,
                        };

                        operationsList.push(operationTemp);
                    } else {
                        var orderTemp = {
                            order_id: orderAndOperations.order_id,
                            description: orderAndOperations.description,
                            order_resp_code: orderAndOperations.order_resp_code,
                            order_section_code: orderAndOperations.order_section_code,
                            scheduled_start_date: orderAndOperations.scheduled_start_date ? orderAndOperations.scheduled_start_date : orderAndOperations.StartDate,
                            scheduled_end_date: orderAndOperations.scheduled_end_date ? orderAndOperations.scheduled_end_date : orderAndOperations.EndDate,
                            reason: orderAndOperations.reason,
                            order_code: orderAndOperations.order_code,
                            priority_code: orderAndOperations.priority_code,
                            priority_id: orderAndOperations.priority_id,
                            site_details_1: orderAndOperations.site_details_1,
                            status_code: orderAndOperations.status_code,
                            status_id: orderAndOperations.status_id,
                            type_code: orderAndOperations.type_code,
                            type_id: orderAndOperations.type_id,
                            team_code: orderAndOperations.team_code,

                            // some other fields not included
                        };
                        orderlist.push(orderTemp);
                    }
                });

                if (orderlist.length > 0) {
                    const differenceOffsetMillis = this.serverOffsetMillis - this.localOffsetMillis;

                    orderlist.map((item: any) => {
                        item.scheduled_start_date = new Date(
                            new Date(item.scheduled_start_date)?.getTime() +
                            differenceOffsetMillis
                        );
                        item.scheduled_end_date = new Date(
                            new Date(item.scheduled_end_date)?.getTime() +
                            differenceOffsetMillis
                        );
                    });
                    // -this.timezone_offset
                    await EditMassOrder(orderlist, () => {
                    }, 0).then(
                        () => {
                            Message.success('Orders are updated successfully');
                        }
                    );
                }
                if (operationsList.length > 0) {
                    await SavePointEdit(operationsList).then(() => {
                    });
                }
                loadingShow(false);
                this.buildQuery();
            } else {
                var sellectedOperations =
                    this.gantObj.selectionModule?.getSelectedRecords();
                var updatedOperation: any[] = [];
                sellectedOperations.map((eachOperation: any) => {
                    var taskData = eachOperation.taskData;

                    let endDate: string | undefined = taskData.scheduled_end_date;
                    let duration: number | undefined = taskData.duration;

                    if (args.scheduled_end_date) {
                        endDate = args.scheduled_end_date;
                    } else {
                        endDate = this.calculateEndDate(
                            args.scheduled_start_date ?? taskData.scheduled_start_date,
                            args.estHours ?? taskData.estHours,
                            args.required ?? taskData.required
                        );
                    }

                    if (args.duration) {
                        duration = args.duration;
                    } else {
                        duration = this.calculateDuration(
                            args.estHours ?? taskData.estHours,
                            args.required ?? taskData.required
                        );
                    }

                    var updatedObject: any = {
                        operationId: parseInt(taskData.operationId),
                        scheduled_start_date:
                            args?.scheduled_start_date ?? taskData.scheduled_start_date,
                        scheduled_end_date: endDate,
                        required: args?.required?.toString(),
                        estHours: args?.estHours,
                        operationDescription: args?.long_description,
                        teamCode: args?.teamCode,
                        tradeCode: args?.tradeCode,
                        shiftId: args?.shiftId,
                        duration: duration?.toString(),
                        longDescription: args?.long_description ?? taskData.longDescription,
                        shift: args?.shift ? args?.shift : taskData.shift,
                    };
                    Object.keys(updatedObject).forEach(
                        (key) =>
                            updatedObject[key] === undefined && delete updatedObject[key]
                    );

                    updatedOperation.push(updatedObject);
                });
                const differenceOffsetMillis = this.serverOffsetMillis - this.localOffsetMillis;

                updatedOperation.map((item: any) => {
                    item.scheduled_start_date = new Date(
                        new Date(item.scheduled_start_date)?.getTime() +
                        differenceOffsetMillis
                    );
                    item.scheduled_end_date = new Date(
                        new Date(item.scheduled_end_date)?.getTime() +
                        differenceOffsetMillis
                    );
                });
                await EditOperations(updatedOperation).then((res) => {
                    if (res.status === 200) {
                        Message.success('Operations are updated successfully');
                        this.buildQuery();
                    }
                });
            }
        }
    };

    private buildQuery = () => {
        ///////////////
        this.current_query = this.current_query.trimEnd();
        this.current_query = this.current_query.replace(this.theQueryPrioritys, '');
        this.current_query = this.current_query.replace(this.theQueryAsset, '');
        this.current_query = this.current_query.replace(
            this.theQueryOutterAsset,
            ''
        );
        this.current_query = this.current_query.replace(this.theQueryDate, '');
        this.current_query = this.current_query.replace(this.theQueryResp, '');
        this.current_query = this.current_query.replace(this.theQueryStatuses, '');
        this.current_query = this.current_query.replace(this.theQueryType, '');
        this.current_query = this.current_query.replace(
            this.theQueryHasProblem,
            ''
        );
        this.current_query = this.current_query.replace(this.theQuerySearch, '');
        this.current_query = this.current_query.replace(this.theQueryPlanId, '');
        this.current_query = this.current_query.replace(this.theQueryReference, '');
        this.current_query = this.current_query.replace(
            this.theQueryWorkOrderCode,
            ''
        );
        this.current_query = this.current_query.replace(
            this.theQueryScheduleNumber,
            ''
        );
        this.current_query = this.current_query.replace(
            this.theQueryDepartment,
            ''
        );
        this.current_query = this.current_query.replace(this.theQuerySection, '');
        this.current_query = this.current_query.replace(
            this.theQueryProntoReference,
            ''
        );
        this.current_query = this.current_query.replace(
            this.theQueryHoldReason,
            ''
        );

        // var o_asset_code = this.outter_asset_code;   OUTTER ASSET CODE
        this.theQueryDepartment = '';
        this.theQuerySection = '';
        this.theQueryProntoReference = '';
        this.theQueryHoldReason = '';
        this.theQueryPrioritys = '';
        this.theQueryStatuses = '';
        this.theQueryAsset = '';
        this.theQueryResp = '';
        this.theQueryType = '';
        this.theQueryHasProblem = '';
        this.theQueryDate = '';
        this.theQuerySearch = '';
        this.theQueryOutterAsset = '';
        this.theQueryReference = '';
        this.theQueryWorkOrderCode = '';
        this.theQueryScheduleNumber = '';

        var thePrioritysMerged = selectedChips.concat(this.priorityFMSComValue);
        var thePurePrioritys = [...new Set(thePrioritysMerged)];
        var thePrioritys = thePurePrioritys?.toString();

        var theDepartment = this.departmentFMSCom?.value?.toString();
        var theSection = this.sectionFMSCom?.value?.toString();
        var theProntoReference = this.prontoReferenceFMSCom?.value?.toString();
        var theHoldReason = this.holdReasonFMSCom?.value?.toString();

        var theStatuses = this.statusFMSCom?.value?.toString();

        var theTypes = this.typeFMSCom?.value?.toString();
        var theHasproblem = this.hasProblem?.value?.toString();
        var theResp = this.respFMSCom?.value?.toString();

        var theReference = this.referenceFMSCom?.value?.toString();
        var theworkorderCode = this.workorderCodeFMSCom?.value?.toString();
        var theScheduleNumber = this.ScheduleNumberFMSCom?.value?.toString();

        var theDate = this.schdeduleStartDateVal;
        var theAssets = this.assetFMSCom?.value?.toString();

        /////////////////
        this.current_query = this.current_query.trimEnd();
        this.current_query = this.current_query.replace(this.theQueryPlanId, '');
        this.current_query = this.current_query.replace(
            this.theQueryIsEffected,
            ''
        );
        this.theQueryPlanId = '';
        this.theQueryIsEffected = '';
        if (this.context.planId !== 0) {
            if (this.current_query !== '') {
                this.theQueryPlanId = addToQuery(
                    'plan_id',
                    '=',
                    'andWhere',
                    this.context.planId?.toString()
                );
            } else {
                this.theQueryPlanId = addToQuery(
                    'plan_id',
                    '=',
                    'where',
                    this.context.planId?.toString()
                );
            }
            this.current_query += this.theQueryPlanId;
        }
        if (this.props.isSuperVisor) {
            if (this.current_query !== '') {
                this.theQueryIsEffected = addToQuery(
                    'is_effected',
                    '=',
                    'andWhere',
                    '1'
                );
            } else {
                this.theQueryIsEffected = addToQuery('is_effected', '=', 'where', '1');
            }
            this.current_query += this.theQueryIsEffected;
        }
        /////////////////////////////////////////////////////

        if (this.checkFilterParams) {
            if (theScheduleNumber === '' || theScheduleNumber === undefined) {
                var theScheduleNumberFromLocalStorage = localStorage.getItem(
                    'textboxPMSchedulerNumberTextComponent'
                );
                if (theScheduleNumberFromLocalStorage) {
                    theScheduleNumber = extractNumbers(theScheduleNumberFromLocalStorage);
                }
            }

            if (theScheduleNumber !== '' && theScheduleNumber !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryScheduleNumber = addToQuery(
                        'pm_schedule_number',
                        'in',
                        'andWhere',
                        theScheduleNumber?.toString()
                    );
                } else {
                    this.theQueryScheduleNumber = addToQuery(
                        'pm_schedule_number',
                        'in',
                        'where',
                        theScheduleNumber?.toString()
                    );
                }
                this.current_query += this.theQueryScheduleNumber;
            }

            if (theworkorderCode === '' || theworkorderCode === undefined) {
                var theScheduleWorkorderFromLocalStorage = localStorage.getItem(
                    'textboxWorkOrderTextBox'
                );
                if (theScheduleWorkorderFromLocalStorage) {
                    theworkorderCode = extractNumbers(
                        theScheduleWorkorderFromLocalStorage
                    );
                }
            }

            if (theworkorderCode !== '' && theworkorderCode !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryWorkOrderCode = addToQuery(
                        'order_code',
                        'in',
                        'andWhere',
                        theworkorderCode?.toString()
                    );
                } else {
                    this.theQueryWorkOrderCode = addToQuery(
                        'order_code',
                        'in',
                        'where',
                        theworkorderCode?.toString()
                    );
                }
                this.current_query += this.theQueryWorkOrderCode;
            }
            if (theSection !== '' && theSection !== undefined) {
                if (this.current_query !== '') {
                    this.theQuerySection = addToQuery(
                        'order_section_code',
                        'in',
                        'andWhere',
                        theSection?.toString()
                    );
                } else {
                    this.theQuerySection = addToQuery(
                        'order_section_code',
                        'in',
                        'where',
                        theSection?.toString()
                    );
                }
                this.current_query += this.theQuerySection;
            }
            if (theProntoReference !== '' && theProntoReference !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryProntoReference = addToQuery(
                        'site_details_1',
                        'in',
                        'andWhere',
                        theProntoReference?.toString()
                    );
                } else {
                    this.theQueryProntoReference = addToQuery(
                        'site_details_1',
                        'in',
                        'where',
                        theProntoReference?.toString()
                    );
                }
                this.current_query += this.theQueryProntoReference;
            }
            if (theHoldReason !== '' && theProntoReference !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryHoldReason = addToQuery(
                        'reason',
                        'in',
                        'andWhere',
                        theHoldReason!.toString()
                    );
                } else {
                    this.theQueryHoldReason = addToQuery(
                        'reason',
                        'in',
                        'where',
                        theHoldReason!.toString()
                    );
                }
                this.current_query += this.theQueryHoldReason;
            }
            if (thePrioritys == '' || thePrioritys == undefined) {
                var thPriorityFromLocalStorage = localStorage.getItem(
                    'multiselectordersFilterMultiPriority'
                );
                var thPriorityFromLocalStorageString = extractCharacters(
                    thPriorityFromLocalStorage
                ).join(',');
                thePrioritys = thPriorityFromLocalStorageString;
            }
            if (thePrioritys !== '' && thePrioritys !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryPrioritys = addToQuery(
                        'priority_code',
                        'in',
                        'andWhere',
                        thePrioritys?.toString()
                    );
                } else {
                    this.theQueryPrioritys = addToQuery(
                        'priority_code',
                        'in',
                        'where',
                        thePrioritys?.toString()
                    );
                }
                this.current_query += this.theQueryPrioritys;
            }

            if (theAssets === '' || theAssets === undefined) {
                var theAssetFromLocalStorage = localStorage.getItem(
                    'textboxAssetTextBox'
                );
                if (theAssetFromLocalStorage) {
                    theAssets = extractStringValue(theAssetFromLocalStorage);
                }
            }
            if (theAssets !== '' && theAssets !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryAsset = addToQuery(
                        'asset_code',
                        'in',
                        'andWhere',
                        theAssets?.toString()
                    );
                } else {
                    this.theQueryAsset = addToQuery(
                        'asset_code',
                        'in',
                        'where',
                        theAssets?.toString()
                    );
                }
                this.current_query += this.theQueryAsset;
            }
            if (theTypes == '' || theTypes == undefined) {
                var theTypeFromLocalStorage = localStorage.getItem(
                    'multiselectoperationFilterMultiType'
                );
                var theTypeFromLocalStorageString = extractCharacters(
                    theTypeFromLocalStorage
                ).join(',');
                theTypes = theTypeFromLocalStorageString;
            }
            if (erpTypeName === ERP_TYPE) {
                if (theTypes !== '' && theTypes !== undefined) {
                    if (this.current_query !== '') {
                        this.theQueryType = addToQuery(
                            'type_id',
                            'in',
                            'andWhere',
                            theTypes?.toString()
                        );
                    } else {
                        this.theQueryType = addToQuery(
                            'type_id',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    }

                    this.current_query += this.theQueryType;
                }
            } else {
                if (theTypes !== '' && theTypes !== undefined) {
                    if (this.current_query !== '') {
                        this.theQueryType = addToQuery(
                            'type_code',
                            'in',
                            'andWhere',
                            theTypes?.toString()
                        );
                    } else {
                        this.theQueryType = addToQuery(
                            'type_code',
                            'in',
                            'where',
                            theTypes?.toString()
                        );
                    }
                    this.current_query += this.theQueryType;
                }
            }

            if (theResp !== '' && theResp !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryResp = addToQuery(
                        'order_resp_code',
                        'in',
                        'andWhere',
                        theResp?.toString()
                    );
                } else {
                    this.theQueryResp = addToQuery(
                        'order_resp_code',
                        'in',
                        'where',
                        theResp?.toString()
                    );
                }
                this.current_query += this.theQueryResp;
            }
            if (theReference === '' || theReference === undefined) {
                var theReferenceFromLocalStorage = localStorage.getItem(
                    'textboxReferenceTextBox'
                );
                if (theReferenceFromLocalStorage) {
                    theReference = extractStringValue(theReferenceFromLocalStorage);
                }
            }

            if (theReference !== '' && theReference !== undefined) {
                if (this.current_query !== '') {
                    this.theQueryReference = addToQuery(
                        'site_details_1',
                        'in',
                        'andWhere',
                        theReference?.toString()
                    );
                } else {
                    this.theQueryReference = addToQuery(
                        'site_details_1',
                        'in',
                        'where',
                        theReference?.toString()
                    );
                }
                this.current_query += this.theQueryReference;
            }
            if (theDate == '' || theDate == undefined) {
                var theScheduleStartDateFromLocalStorage = localStorage.getItem(
                    'daterangepickerScheduleStartDateFilter'
                );
                if (theScheduleStartDateFromLocalStorage) {
                    const parsedData = JSON.parse(theScheduleStartDateFromLocalStorage);
                    if (parsedData.startDate && parsedData.endDate && parsedData.value) {
                        theDate = convertToDate({
                            startDate: parsedData.startDate,
                            endDate: parsedData.endDate,
                            value: parsedData.value,
                        });
                    }
                }
            }
            if (theDate !== '' && theDate && theDate !== undefined) {
                if (theDate.length > 0) {
                    if (this.current_query !== '') {
                        // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
                        // var end_date = moment(theDate[1]).format('yyyy-MM-DD');

                        var start_date = new Date(
                            new Date(theDate[0]).getTime() -
                            new Date().getTimezoneOffset() * 60 * 1000
                        ).toISOString();
                        var end_date = new Date(
                            new Date(theDate[1].setHours(23, 59, 59)).getTime() -
                            new Date().getTimezoneOffset() * 60 * 1000
                        ).toISOString();

                        this.theQueryDate = addToQuery(
                            'planned_start_date',
                            '>=',
                            'andWhere',
                            start_date
                        );
                        this.theQueryDate += addToQuery(
                            'planned_start_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    } else {
                        // var start_date = moment(theDate[0]).format('yyyy-MM-DD');
                        // var end_date = moment(theDate[1]).format('yyyy-MM-DD');

                        var start_date = new Date(
                            new Date(theDate[0]).getTime() -
                            600 * 60 * 1000 -
                            new Date().getTimezoneOffset() * 60 * 1000
                        ).toISOString();

                        var end_date = new Date(
                            new Date(theDate[1].setHours(13, 59, 59)).getTime() -
                            new Date().getTimezoneOffset() * 60 * 1000
                        ).toISOString();
                        this.theQueryDate = addToQuery(
                            'planned_start_date',
                            '>=',
                            'where',
                            start_date
                        );
                        this.theQueryDate += addToQuery(
                            'planned_end_date',
                            '<=',
                            'andWhere',
                            end_date
                        );
                    }
                    this.current_query += this.theQueryDate;
                }
            }
            // if (o_asset_code !== '' && o_asset_code !== undefined) {
            //   if (this.the_current_query !== '') {
            //     this.theQueryOutterAsset = addToQuery(
            //       'asset_code',
            //       'in',
            //       'andWhere',
            //       o_asset_code.trim()
            //     );
            //   } else {
            //     this.theQueryOutterAsset = addToQuery(
            //       'asset_code',
            //       'in',
            //       'where',
            //       o_asset_code.trim()
            //     );
            //   }
            //   this.the_current_query += this.theQueryOutterAsset;
            // }
        }
        if (this.searchText !== '' && this.searchText) {
            this.theQuerySearch = '$' + this.searchText;
            this.current_query = this.current_query + this.theQuerySearch;
        }
        this.setState({ loadSignal: true });
        this.setState({
            current_query: this.current_query,
        });
        this.props.setSearchCaseOrder('');
        this.checkFilterParams = true;

        this.getPlanOrderGant(this.current_query).then(() => {
            this.restoreExpandedRows();
        });


    };

    select(args: any) {
        let workingDays: Array<any> = [];
        if (this.multiselectObj.value) {
            workingDays = this.multiselectObj.value;
        }
        workingDays.push(args.itemData.day);
        this.gantObj.workWeek = workingDays;
    }

    ///DialogButton Submit
    setProgressGanttRecords() {
        this.allowToFire = false;
        let theAllChildsFromParent: Array<any> = [];
        var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        var theParents: Array<string> = [];
        if (!this.percentageNumber.value) {
            Message.error('Value must be between %0-%100');
            return;
        }
        theData?.map((theEl: any) => {
            if (!theEl.hasChildRecords) {
                theAllChildsFromParent.push(theEl);
                theParents.push(theEl.parentItem.index);
            }
        });
        const parents = new Set(theParents.map((el) => el));
        theParents = Array.from(parents);
        theParents.map((el) => {
            var theSelectedData = this.gantObj.flatData[parseInt(el)] as any;
            theSelectedData.isDone = true;
            setTimeout(() => {
                this.gantObj.updateRecordByID(theSelectedData);
            }, 0);
        });
        theAllChildsFromParent?.map((theChild, index) => {
            if (index === theAllChildsFromParent.length - 1) {
                this.allowToFire = true;
            }
            var theSelectedData = this.gantObj.flatData[theChild.index] as any;
            theSelectedData.Progress = this.percentageNumber.value;
            theSelectedData.isDone = true;
            setTimeout(() => {
                this.gantObj.updateRecordByID(theSelectedData);
            }, 0);
        });
        this.setState({
            currentDialogSettings: {
                ...this.state.currentDialogSettings,
                show: false,
            },
        });
    }

    applyConfirm() {
        if (this.props.current_plan_data) {
            this.props.current_plan_data.isLocked = !this.props.current_plan_data.isLocked;
            this.editPlans(this.props.current_plan_data);
            this.setState({
                currentDialogSettings: {
                    ...this.state.currentDialogSettings,
                    show: false,
                },
            });
        }
    }

    confirmSchedulerTime = (event: any) => {
        if (event.value) {
            const newDate = new Date(event.value);
            newDate.setHours(6, 0, 0, 0);
            this.setState({
                defaultConfirmScheduleDate: newDate,
            });
        }
    };
    approveSendBack = () => {
        this.batch_obj = [];
        this.theCurrentEl.level = 0;
        let theResult = '';
        var theData: any;
        if (this.reasonCodes.value) {
            theData = this.reasonCodes.getDataByValue(
                this.reasonCodes.value.toString()
            ) as any;
        }
        if (this.reasonCodes.text) {
            theResult = this.reasonCodes.text;
        }
        if (this.reasonDesc.value) {
            theResult = theResult + ' ' + this.reasonDesc.value + '$' + theData.color;
        } else {
            theResult = theResult + '$' + theData.color;
        }
        this.theCurrentEl.reason =
            theResult + '^&&' + this.theCurrentEl.taskData.reason;
        this.batch_obj = [];
        arrayPreparing(
            [{ ...this.theCurrentEl }],
            this.batch_obj,
            this.state.allowSeg,
            this.state.dayWorkingTime,
            this.state.ShiftElementData
        );
        SavePointOfTheGantt(this.batch_obj, () => {
            $('#cloudSchedulerSavePoint').removeAttr('disabled');
            this.setState({
                currentDialogSettings: {
                    ...this.state.currentDialogSettings,
                    show: false,
                },
            });
        });
    };

    refreshSchedulerGanttRecords() {
        this.buildQuery();
        this.modifiedDatas = [];
        //this.setState({query: this.queryForLoad});
        this.context.setLoadAllowChange(true);
    }

    schedulerGanttRecords() {
        if (this.dateTimePicker.value === null) {
            Message.error('Scheduler date is mandatory');
            return;
        }

        this.reSchedulerGantt(
            false,
            '',
            this.dateTimePicker.value,
            undefined,
            undefined,
            true,
            undefined,
            true,
            'edit-button'
        );
    }

    //DialogContent and Related Functions
    private onCreateConditionTextArea = (): void => {
        this.reasonDesc.addAttributes({ rows: 5 });
        this.reasonDesc.respectiveElement.style.height = '200px';
        this.reasonDesc.respectiveElement.style.overflow = 'auto';
        this.reasonDesc.respectiveElement.style.maxHeight = '200px';
    };
    private contentOfExeption = () => {
        return (
            <div className='flex-group-field'>
                <label htmlFor='Task' className='label-control col-md-3'>
                    Exeption
                </label>
                <div className='col-md-12'>
                    <DropDownListComponent
                        onFocus={() => {
                            axios
                                .get(GetBackendUrlForGlobalFunctions() + 'scheduler-generals', {
                                    cancelToken: this.source.token,
                                })
                                .then((res) => {
                                    this.reasonCodes.dataSource = res.data.map((el: any) => {
                                        return {
                                            ...el,
                                            name: el.name + ' ' + el.description,
                                        };
                                    });
                                });
                        }}
                        fields={{ text: 'name', value: 'ID' }}
                        placeholder='Task'
                        valueTemplate={this.itemTemplate.bind(this)}
                        itemTemplate={this.itemTemplate.bind(this)}
                        ref={(scope: DropDownListComponent) => {
                            this.reasonCodes = scope;
                        }}
                    />
                </div>
                <label className='label-control col-md-3'>Description</label>
                <div className='col-md-12'>
                    <TextBoxComponent
                        created={this.onCreateConditionTextArea}
                        ref={(scope) => {
                            this.reasonDesc = scope;
                        }}
                        multiline={true}
                        style={{ maxHeight: '100px' }}
                    />
                </div>
            </div>
        );
    };
    private onChipClik = (args: any) => {
        if (args.index === 0) {
            this.percentageNumber.value = 25;
        } else if (args.index === 1) {
            this.percentageNumber.value = 50;
        } else if (args.index === 2) {
            this.percentageNumber.value = 75;
        } else {
            this.percentageNumber.value = 100;
        }
    };
    private contentOfPercentage = () => {
        return (
            <div>
                <ChipListComponent
                    id='chip-choice'
                    selection='Single'
                    cssClass='e-outline'
                    selectedChips={[1]}
                    click={this.onChipClik}
                >
                    <ChipsDirective>
                        <ChipDirective
                            text='25%'
                            leadingIconCss='e-medium-ico'
                        ></ChipDirective>
                        <ChipDirective
                            text='50%'
                            leadingIconCss='e-small-icon'
                        ></ChipDirective>
                        <ChipDirective
                            text='75%'
                            leadingIconCss='chip-choice'
                        ></ChipDirective>
                        <ChipDirective
                            text='100%'
                            leadingIconCss='chip-choice'
                        ></ChipDirective>
                    </ChipsDirective>
                </ChipListComponent>
                <div>
                    <NumericTextBoxComponent
                        ref={(ref: NumericTextBoxComponent) => (this.percentageNumber = ref)}
                        max={100}
                        min={0}
                        width={'100%'}
                    />
                </div>
            </div>
        );
    };
    private contentOfConfirm = () => {
        return (
            <div>
                Do you realy want to lock this plan. It may cause some unexpected
                beaviour.
            </div>
        );
    };

    private itemTemplateReasonValue(data: any): JSX.Element {
        return (
            <span>
                <span
                    id='exceptiontColor'
                    style={{ backgroundColor: data.color }}
                ></span>
                <span>{data.description}</span>
            </span>
        );
    }

    private contentOfHistory = () => {
        let theValues: string = this.theCurrentEl.taskData.reason;
        let theDataSource: Array<any> = [];
        if (theValues && theValues !== null) {
            let theReasons = theValues?.split('^&&');
            theReasons.map((els) => {
                let theParsing = els?.split('$');
                let theColor;
                if (theParsing.length > 0) theColor = theParsing[1];
                theDataSource.push({ description: theParsing[0], color: theColor });
            });
        } else {
            theDataSource = [{ description: 'No data to show.', color: '#fff' }];
        }
        return (
            <div>
                <span>History</span>
                <ListViewComponent
                    className={'hiddenListElement'}
                    id='cloudscheduler-list-flat'
                    dataSource={theDataSource}
                    template={this.itemTemplateReasonValue.bind(this)}
                    cssClass='e-list-template'
                    animation={{
                        effect: 'SlideLeft',
                        duration: 500,
                        easing: 'ease',
                    }}
                    height={'200px'}
                ></ListViewComponent>
            </div>
        );
    };

    ///Helpers
    ConvertToSchedule(planned: any, schedule: any) {
        let val = planned;
        let indexOf = schedule.indexOf('(-');
        if (indexOf != -1) val = schedule;
        var num = parseInt(val.substring(6, 19));
        //var num = parseInt(str.replace(/[^09]/g, ""));
        var date = new Date(num);
        const month = date.getMonth();
        const day = date.getDate();
        const year = date.getFullYear();
        const result =
            (month < 10 ? '0' + month : month) +
            '/' +
            (day < 10 ? '0' + day : day) +
            '/' +
            year;
        return result;
    }

    ConvertToDateToGantModule(val: any) {
        var num = parseInt(val.substring(6, 19));
        var date = moment(num).format('MM/DD/yyyy');
        return new Date(date);
    }

    calculateClose() {
        if (this.condition) {
            this.gantObj.height = 'calc(-390px + 100vh)';
        } else {
            this.gantObj.height = 'calc(-90px + 100vh)';
        }
        this.condition = !this.condition;
    }

    getTimeZoneDifference() {
        var tz = moment(new Date()).utcOffset();
        //var result = tz - -300;
        return tz * 60000;
    }

    itemTemplate(data: any): JSX.Element {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '5px',
                    marginLeft: '5px',
                }}
            >
                <div
                    style={{
                        backgroundColor: data.color,
                        width: '20px',
                        height: '20px',
                        borderRadius: '5px',
                    }}
                ></div>
                <span>{data.description}</span>
            </div>
        );
    }

    //OnClickEvent

    onChange(sel: { itemData: { text: string; value: string } }): void {
        this.gantObj.filterSettings.type = sel.itemData.value as FilterType;
        this.gantObj.clearFiltering();
    }

    private modifiedDatas: any = [];

    async actionCompletedElement(args: any) {
        if (args.requestType === 'refresh') {
            this.gantObj?.dataBind();
        }
        if (args.requestType === 'validateLinkedTask') {
            document
                .getElementById('ganttContainer')
                ?.classList.remove('e-spin-show');
        }

        if (args.action === 'DialogEditing') {
            if (this.allowToFire) {
                this.batch_obj = [];
            }
            this.modifiedDatas.push(args.modifiedRecords);
            this.reSchedulerGantt(
                false,
                '',
                args.data.StartDate,
                undefined,
                undefined,
                undefined,
                false,
                false,
                'edit-button'
            );
            this.props.dispatch(setCloudSchedularGantDataChanged(true));
        }
        if (args.action === 'TaskbarEditing') {
            if (this.allowToFire) {
                this.batch_obj = [];
            }
            this.modifiedDatas.push(args.modifiedRecords);
            this.reSchedulerGantt(
                false,
                '',
                args.data.StartDate,
                undefined,
                undefined,
                undefined,
                false,
                false,
                'drag'
            );
            this.props.dispatch(setCloudSchedularGantDataChanged(true));
        } else if (args.requestType === 'save' && args.action === 'CellEditing') {
            if (this.allowToFire) {
                this.batch_obj = [];
            }
            this.modifiedDatas.push(args.modifiedRecords);
            loadingShow(true);
            let operationData = arrayPreparing(
                this.modifiedDatas,
                this.batch_obj,
                this.state.allowSeg,
                this.state.dayWorkingTime,
                this.state.ShiftElementData
            );

            const FIXED_UTC_HOUR = this.server_gmt ? this.server_gmt : 11;
            const getHourDifference = (): number => {
                const browserOffsetInMinutes = new Date().getTimezoneOffset();
                const browserOffsetInHours = -browserOffsetInMinutes / 60;
                return FIXED_UTC_HOUR - browserOffsetInHours;
            };

            const addHoursToDate = (dateStr: string, hours: number): string => {
                const date = new Date(dateStr);
                date.setHours(date.getHours() + hours);
                return date.toISOString();
            };

            const hourDiff = getHourDifference();

            operationData.datas = operationData.datas.map((item: any) => ({
                ...item,
                scheduled_start_date: addHoursToDate(item.scheduled_start_date, hourDiff),
                scheduled_end_date: addHoursToDate(item.scheduled_end_date, hourDiff),
            }));

            await EditOperations(operationData.datas)
                .then(() => {
                    loadingShow(false);
                    this.operationDatas = [];
                    this.modifiedDatas = [];
                })
                .catch((err: any) => {
                });
        } else if (args.requestType === 'save') {
            if (this.allowToFire) {
                this.batch_obj = [];
            }
            if (true) {
                //const filteredSubtasks = args.modifiedTaskData.filter((task: any) => task.subtasks);
                const allSubtasks = args.modifiedTaskData.flatMap(
                    (task: any) => task.subtasks || []
                );
                this.modifiedDatas = []
                allSubtasks.map((each: any) => {
                    this.modifiedDatas.push(each);

                });
                // this.modifiedDatas.push(allSubtasks);
                this.setState({ allowBatchArray: false });
            }

            //document.getElementById("cloud-scheduler-gantt")?.classList.remove("e-spin-show");
        }
        document?.querySelector('.e-spinner-pane')?.remove();
    }

    private operationDatas: any = [];

    async EditOperationAndOrderDatas(isMultipleSchedule: boolean = false, taskbarEditingType?: string) {
        let tempModifiedDatas = this.modifiedDatas;
        const operationData = arrayPreparing(
            tempModifiedDatas,
            this.batch_obj,
            this.state.allowSeg,
            this.state.dayWorkingTime,
            this.state.ShiftElementData,
            isMultipleSchedule,
        );

        const offsetDiff = this.serverOffsetMillis - this.localOffsetMillis;
        const adjustedDatas = getAdjustedDatas(operationData.datas, taskbarEditingType, offsetDiff, this.serverOffsetMillis);

        try {
            const uniqueAdjustedDatas = adjustedDatas.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => t.operationId === item.operationId)
            );

            await EditOperations(uniqueAdjustedDatas);
            loadingShow(false);
            this.setState({ allowBatchArray: true });

            if (
                tempModifiedDatas[1]?.length === 2 &&
                tempModifiedDatas[1][0]?.taskData.duration !== tempModifiedDatas[1][1]?.taskData.duration
            ) {
                this.refreshSchedulerGanttRecords();
            }

            this.modifiedDatas = [];
            this.operationDatas = [];
            tempModifiedDatas = [];
            this.buildQuery();

            if (this.allowToFire) {
                // SavePointOfTheGantt(...); // Un-comment when needed
            }

        } catch (error) {
            console.error("EditOperations error", error);
        }
    }

    taskbarEditing(args: any) {
        if (
            args.taskBarEditAction == 'LeftResizing' ||
            args.taskBarEditAction == 'RightResizing'
        ) {
            args.cancel = true;
        }
    }
    excelQueryCellInfo = (args: any) => {
        const data = args.data;

        if (!data || Object.keys(data).length === 0) {
            return;
        }

        const baseFontStyle = {
            fontName: 'Verdana',
            fontSize: 10,
            wrapText: true,
        };

        if (args.column?.field === 'WorkOrderDescription' && !data.isHeader && !data.isFooter) {
            args.cellValue = '';
            return;
        }

        if (data.isHeader) {
            args.style = {
                ...baseFontStyle,
                backColor: '#000000',
                fontColor: '#FFFFFF',
                bold: true,
            };
            return;
        }

        if (data.isFooter) {
            args.style = {
                ...baseFontStyle,
                backColor: '#FCE4D6',
                bold: true,
            };
            return;
        }

        if (['CC', 'HC', 'ST'].includes((data.site_details_1 || '').trim()) && args.column?.field === 'TaskName') {
            args.style = {
                ...baseFontStyle,
                backColor: '#FFFF00',
            };
            return;
        }

        if (data.pm_schedule_id == null && args.column?.field === 'TaskName') {
            args.style = {
                ...baseFontStyle,
                backColor: '#C6EFCE',
            };
            return;
        }

        if (data.pm_id != null && args.column?.field === 'TaskName') {
            args.style = {
                ...baseFontStyle,
                backColor: '#FFFF00',
            };
            return;
        }


        const dateStr = data.taskData.StartDate || data.StartDate;
        if (dateStr) {
            const date = new Date(dateStr);
            const hour = date.getHours();

            if (!isNaN(hour)) {
                if (hour >= 6 && hour < 18) {
                    args.style = {
                        ...baseFontStyle,
                        backColor: '#FFFFFF',
                    };
                } else {
                    args.style = {
                        ...baseFontStyle,
                        backColor: '#D9D9D9',
                    };
                }
            }
        }
    };





    private async actionBegin(args: any) {
        if (

            args.action === 'DrawConnectorLine'
        ) {
            let dependencyInfo: DependencyInfo = args.data?.Predecessor && parseDependencyCode(args.data?.Predecessor);
            const result = args.data?.Predecessor.includes(",");
            if (result) {
                Message.info("More than one parent not allowed.")
                args.cancel = true;
            }
            else {
                if (dependencyInfo.dependencyType === 'FS' || args.data?.Predecessor === '') {
                    let obj: UpdateDependencyType = {
                        operationId: args.data?.TaskID,
                        dependencyCode: args.data?.Predecessor,
                        startDate: args.data?.StartDate,
                        endDate: args.data?.EndDate,
                        uniqueDependencyCode: args.data?.uniqueDependencyCode,
                    };
                    await updateDependency(obj);
                    this.refreshSchedulerGanttRecords();
                }
                else {
                    Message.info("Only 'FS' dependency type is allowed.")
                    args.cancel = true;
                    //this.refreshSchedulerGanttRecords();
                }
            }

        }
        if (args.requestType === 'validateLinkedTask') {
            if (
                args.editEventArgs.taskBarEditAction === 'ParentDrag' ||
                args.editEventArgs.action === 'DialogEditing'
            ) {
                args.validateMode.respectLink = false;
            } else {
                args.validateMode.respectLink = true;
            }
        }
        if (args.requestType === 'taskbarediting' && (args.taskBarEditAction == 'ChildDrag' || args.taskBarEditAction == 'ParentDrag')) {
            // this.selectedChildList = []
        }
        if (args.requestType === 'taskbarediting') {
            // if (args.taskBarEditAction === 'RightResizing') {
            //   args.cancel = true;
            //   return;
            // }
            // if (args.taskBarEditAction === 'LeftResizing') {
            //   args.cancel = true;
            //   return;
            // }
        }
        if (args.requestType === 'beforeSave') {
            // args?.modifiedRecords.map((res: any) => {
            //   if (res.level === 0) {
            //     if (this.state.maxSchedulerPeriod === 0) {
            //       return;
            //     }
            //     res.childRecords.map((el: any) => {
            //       let theRangeEnd = Math.abs(
            //         moment(el.EndDate).diff(el.taskData.scheduled_end_date, 'days')
            //       );
            //       let theRangeStart = Math.abs(
            //         moment(el.StartDate).diff(el.taskData.scheduled_start_date, 'days')
            //       );
            //       let thePeriod = Number(this.state.maxSchedulerPeriod);
            //       if (theRangeEnd > thePeriod || theRangeStart > thePeriod) {
            //         args.cancel = true;
            //         Message.error(
            //           'Max scheduled range has exceeded. The Range must be 0-' +
            //             thePeriod
            //         );
            //         return;
            //       }
            //     });
            //   }
            // });
        }
    }

    private onLocked() {
        if (!this.props.current_plan_data.isLocked) {
            this.setState({
                currentDialogSettings: {
                    width: '300px',
                    height: 'auto',
                    firstButtonText: 'Yes',
                    seccondButtonText: 'No',
                    type: 'confirm',
                    content: this.contentOfConfirm.bind({}),
                    show: true,
                },
            });
        } else {
            if (this.props.current_plan_data) {
                this.props.current_plan_data.isLocked = !this.props.current_plan_data.isLocked;
                this.editPlans(this.props.current_plan_data);
            }
        }
    }

    setPercentage() {
        this.reSchedulerGantt(
            false,
            undefined,
            undefined,
            true,
            this.percentage.value
        );
    }

    teamAssignment() {
        const selectedElements = this.current_data as any[];

        const selectedTeamCode = this.assignTeamDropDown?.text;
        const selectedTeamValue = this.assignTeamDropDown?.value;

        if (selectedTeamValue === undefined || selectedTeamValue === null) {
            Message.error('You should select a team');
            return;
        }

        if (!Array.isArray(selectedElements) || selectedElements.length === 0) {
            Message.error('No operations selected');
            return;
        }

        const obj = selectedElements.map((el) => {

            return {
                operationId: el.TaskID,
                teamCode: selectedTeamCode,
                createdBy: all_information.user_id
            };
        });

        loadingShow(true);

        EditOperations(obj)
            .then(() => {
                Message.success('Success');
                this.context.setLoadAllowChange(true);
                this.buildQuery();
                this.setState({ hideAssignTeamDialog: false });
            })
            .catch((err: any) => {
                const msg =
                    err.response?.data + '\n' + err.response?.status + '\n' + err.response?.headers ||
                    err.request ||
                    'Error: ' + err.message;

                Message.error(msg);
            })
            .finally(() => {
                loadingShow(false);
            });
    }


    shiftAssignment() {
        const selectedElements = this.current_data;
        const shiftText = this.dropDownListObjectShiftElment?.text;
        const shiftId = this.dropDownListObjectShiftElment?.value;

        if (!shiftId) {
            Message.error('You should select a shift');
            return;
        }

        if (!selectedElements?.length) return;

        const workingTime = this.state.dayWorkingTime?.[0];
        const allowSeg = this.state.allowSeg;

        const obj = selectedElements.map((el: any) => {
            let workingHour = 0;

            if (shiftText && workingTime) {
                workingHour = Number(workingTime.to - workingTime.from);
            } else {
                const matchedShift = this.state.ShiftElementData.find(
                    (s) => s.rosterCode === shiftText && s.rosterType === 'Shift'
                );

                if (matchedShift) {
                    const [hourStr, minStr] = matchedShift.duration.split(':');
                    let hours = Number(hourStr);
                    const minutes = Number(minStr);
                    if (hours === 23 && minutes === 59) hours = 24;

                    workingHour = hours;
                }
            }

            generateSegmentation(el, workingHour, allowSeg);

            return {
                operationId: el.TaskID,
                shift: shiftText,
                shiftId: shiftId,
                createdBy: all_information.user_id,
                Segments: el?.taskData?.Segments?.map((seg: any) => ({
                    StartDate: seg.StartDate,
                    Duration: seg.Duration,
                    operationId: el.TaskID,
                })) || [],
            };
        });

        EditOperations(obj)
            .then(() => {
                Message.success('Success');
                loadingShow(false);
                this.context.setLoadAllowChange(true);
                this.buildQuery();
                this.setState({ hideDeleteDialog: false });
            })
            .catch((err: any) => {
                const errorMessage = err.response
                    ? `${err.response.data}\n${err.response.status}\n${err.response.headers}`
                    : err.request || `Error: ${err.message}`;
                Message.error(errorMessage);
                loadingShow(false);
            });
    }

    public FilterOptions: FilterSettingsModel = { type: 'Menu' };

    private itemTemplateShiftColor(data: any): JSX.Element {
        return (
            <span>
                <span
                    id='exceptiontColor'
                    style={{ backgroundColor: data.rostercolor }}
                ></span>
                <span>{data.rosterCode + ' - ' + data.description}</span>
            </span>
        );
    }

    public contextMenuItems: any = [
        'AutoFitAll',
        'AutoFit',
        'TaskInformation',
        'DeleteTask',
        'Save',
        'Cancel',
        'SortAscending',
        'SortDescending',
        'Add',
        'DeleteDependency',
        'Convert',
        'Indent',
        'Split Task',
        'Outdent',
        {
            text: 'Collapse the Row',
            target: '.e-content',
            id: 'collapserow',
        } as ContextMenuItemModel,
        {
            text: 'Expand the Row',
            target: '.e-content',
            id: 'expandrow',
        } as ContextMenuItemModel,
        // {
        //   text: 'Assign Shift',
        //   target: '.e-content',
        //   id: 'asignshift',
        // } as ContextMenuItemModel,
    ];

    removed(args: any) {
        let index = this.gantObj.workWeek.indexOf(args.itemData.day);
        if (index !== -1) {
            this.gantObj.workWeek = this.multiselectObj.value as any;
        }
    }

    async toolbarClick(args: any) {
        if (args.item.id === 'CsvExport') {
            this.gantObj.csvExport();
        }

        if (args.item.id === 'PdfExport') {
            this.gantObj.pdfExport({

                pageSize: 'A0',
                showPredecessorLines: true,
                pageOrientation: 'Landscape',
                enableFooter: true,
                theme: 'Bootstrap 4',
                ganttStyle: {
                    // columnHeader:{
                    //   padding:new PdfPaddings(2,2,2,2)
                    // }
                },
                exportType: 'CurrentViewData',
            });
        }


        if (args.item.id === 'ExcelExport') {
            //this.gantObj.excelExport();
            const ganttData = this.gantObj?.currentViewData;
            const grouped = groupTasksByDate(ganttData);
            const transformed = transformToMultiTableFormat(grouped);
            args.data = transformed;

            this.gantObj.excelExport({
                dataSource: transformed,
                columns: this.excelExportsColumns,
            });
            //this.refreshSchedulerGanttRecords();
        }

        if (args.item.id === 'ZoomIn') {
            this.gantObj?.zoomIn();
        }
        if (args.item.id === 'ZoomOut') {
            this.gantObj?.zoomOut();
            // this.gantObj?.excelExport();
        }
        if (args.item.id === 'ExpandAll') {
            this.gantObj?.expandAll();
        }
        if (args.item.id === 'CollapseAll') {
            this.gantObj?.collapseAll();
        }

        if (args.item.id === 'gantDetails') {
            this.setState({
                displayGantInformation: !this.state.displayGantInformation,
            });
        }

        if (args.item.id === 'cloud-scheduler-gantt_csvexport') {
            this.gantObj.csvExport();
        } else if (args.item.id === 'cloud-scheduler-gantt_pdfexport') {
            this.gantObj.pdfExport({
                pageSize: 'A0',
                showPredecessorLines: true,
                enableFooter: true,
                theme: 'Bootstrap 4',
                ganttStyle: {
                    // columnHeader:{
                    //   padding:new PdfPaddings(2,2,2,2)
                    // }
                },
                includeHiddenColumn: false,
                exportType: 'CurrentViewData',
            });
        }
        if (args.item.id === 'assignshift') {
            const selectedRecords = this.gantObj.selectionModule.getSelectedRecords() as any[];

            if (selectedRecords.length === 0) {
                Message.error('No records selected to Assign');
                return;
            }

            // Tüm child'ları toplayalım veya doğrudan kendisini
            const datas: any[] = selectedRecords.flatMap((record: any) =>
                record.hasChildRecords ? record.childRecords : [record]
            );

            this.current_data = datas;
            this.setState({ hideDeleteDialog: true });
        }

        if (args.item.id === 'assignteam') {
            const selectedRecords = this.gantObj.selectionModule.getSelectedRecords() as any[];

            if (selectedRecords.length === 0) {
                Message.error('No records selected to Assign');
                return;
            }

            const datas: any[] = [];

            for (const data of selectedRecords) {
                if (data.hasChildRecords && Array.isArray(data.childRecords)) {
                    datas.push(...data.childRecords);
                } else {
                    datas.push(data);
                }
            }

            this.current_data = datas;
            setTimeout(() => {
                this.setState({ hideAssignTeamDialog: true });
            }, 0);
        }

        if (args.item.id === 'percentage') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
                if (theData[0].hasChildRecords) {
                    this.current_data = theData[0].childRecords;
                    this.setState({ hidePercentage: true });
                } else {
                    this.current_data = [{ ...theData[0] }];
                    this.setState({ hidePercentage: true });
                }
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'assign_workorders') {
            if (this.props.current_plan_id !== 0) {
                this.setState({ hideDialogOrder: true });
            } else {
                Message.error('No plan selected to Assign');
            }
        }
        if (args.item.id === 'scheduler') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                if (this.state.current_plan_isLocked) {
                    Message.warning(
                        'This plan has been locked down. This is not alowed to procced'
                    );
                    return;
                }
                this.setState({ hideSchedulerTimeDialog: true });
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'done') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                this.setState({
                    currentDialogSettings: {
                        width: '300px',
                        height: 'auto',
                        firstButtonText: 'Save',
                        seccondButtonText: 'Cancel',
                        type: 'done',
                        content: this.contentOfPercentage.bind({}),
                        show: true,
                    },
                });
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'next') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                this.reSchedulerGantt(
                    true,
                    'next',
                    undefined,
                    undefined,
                    undefined,
                    true,
                    undefined,
                    true,
                    'edit-button'
                );
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'previous') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                this.reSchedulerGantt(
                    true,
                    'previous',
                    undefined,
                    undefined,
                    undefined,
                    true,
                    undefined,
                    true,
                    'edit-button'
                );
            } else {
                Message.error('No records selected to Assign');
            }
        }
        if (args.item.id === 'reject') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
                if (theData.hasChildRecords || theData[0].level === 0) {
                    this.theCurrentEl = theData[0];
                    this.theCurrentEl.isRejected = true;
                    this.theCurrentEl.is_effected = false;
                    this.theCurrentEl.order_id = this.theCurrentEl.TaskID;
                } else {
                    let theParentData = this.gantObj.getRecordByID(
                        theData[0].parentItem.taskId
                    );
                    this.theCurrentEl = theParentData;
                    this.theCurrentEl.isRejected = true;
                    this.theCurrentEl.is_effected = false;
                    this.theCurrentEl.order_id = this.theCurrentEl.TaskID;
                }
                this.setState({
                    currentDialogSettings: {
                        width: '500px',
                        height: 'auto',
                        firstButtonText: 'Save',
                        seccondButtonText: 'Cancel',
                        type: 'exeption',
                        content: this.contentOfExeption.bind({}),
                        show: true,
                    },
                });
            }
        }
        if (args.item.id === 'history') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
                if (theData.hasChildRecords || theData[0].level === 0) {
                    this.theCurrentEl = theData[0];
                } else {
                    let theParentData = this.gantObj.getRecordByID(
                        theData[0].parentItem.taskId
                    );
                    this.theCurrentEl = theParentData;
                }
                this.setState({
                    currentDialogSettings: {
                        width: '500px',
                        height: 'auto',
                        firstButtonText: 'OK',
                        seccondButtonText: 'Cancel',
                        type: 'history',
                        content: this.contentOfHistory.bind({}),
                        show: true,
                    },
                });
            }
        }
        if (args.item.id === 'refresh') {
            this.refreshSchedulerGanttRecords();
        }
        if (args.item.id === 'commit') {
            if (this.gantObj.selectionModule.getSelectedRecords().length !== 0) {
                let objects: Array<any> = [{ module: 'scheduler' }];
                var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
                var parentdata: any;
                theData.map((data: any) => {
                    if (data.parentUniqueID == undefined || data.parentUniqueID == null) {
                        let obj = {
                            scheduled_start_date: data.StartDate,
                            scheduled_end_date: data.EndDate,
                            order_code: data.order_code,
                        };
                        objects.push(obj);
                    } else {
                        parentdata = this.gantObj?.getTaskByUniqueID(
                            data.parentUniqueID
                        ) as any;
                        let obj = {
                            scheduled_start_date: parentdata.StartDate,
                            scheduled_end_date: parentdata.EndDate,
                            order_code: parentdata.order_code,
                        };
                        objects.push(obj);
                    }
                });
                objects = Array.from(
                    new Set(objects.map((item: any) => JSON.stringify(item)))
                ).map((item) => JSON.parse(item));
                var theCurrentEl: any = [];
                if (theData.hasChildRecords || theData[0].level === 0) {
                    theCurrentEl = { ...theData[0].taskData };
                    theCurrentEl.isRejected = false;
                    theCurrentEl.is_effected = true;
                    theCurrentEl.order_id = theCurrentEl.TaskID;
                } else {
                    let theParentData = this.gantObj.getRecordByID(
                        theData[0].parentItem.taskId
                    );
                    theCurrentEl = { ...theParentData.taskData };
                    theCurrentEl.isRejected = false;
                    theCurrentEl.is_effected = true;
                    theCurrentEl.order_id = theCurrentEl.TaskID;
                }
                theCurrentEl.subtasks = undefined;
                this.batch_obj.push(theCurrentEl);
                SavePointOfTheGantt(this.batch_obj, () => {
                    this.setState({
                        currentDialogSettings: {
                            ...this.state.currentDialogSettings,
                            show: false,
                        },
                    });
                });
                let current_query = '';

                this.gantObj.showSpinner();
                EditProntoOrders(objects)
                    .then((result: AxiosResponse) => {
                        this.gantObj.hideSpinner();
                        if (result.data.status == 200) {
                            loadingShow(false);
                            Message.success(`${result.data.message}...`);
                        }
                        if (result.data.status == 401 || result.data.status == 500) {
                            loadingShow(false);
                            Message.error(`${result.data.message}...`);
                        }
                        this.buildQuery();
                        this.context.setLoadAllowChange(true);
                    })
                    .catch((err) => {
                        loadingShow(false);
                        Message.error('Update failed!!!');
                    });
            }
        }

        if (args.item.id === 'reset_pronto_data') {
            if (this.gantObj.selectionModule?.getSelectedRecords().length > 0) {
                let theTableName = await GetTablenameFromTask('ORDERS');
                if (theTableName === '') {
                    theTableName = 'job5mfj';
                } else {
                    theTableName = theTableName.trim();
                    let theValue = theTableName.split(' ');
                    theTableName = theValue[theValue.length - 1];
                }

                var selectedOrderDatas = this.gantObj.selectionModule
                    ?.getSelectedRecords()
                    .filter((orderandOp: any) => {
                        if (orderandOp.order_code != null) {
                            return orderandOp;
                        }
                    });

                let theRowIds = selectedOrderDatas
                    .map((x: any) => x.pronto_row_id)
                    .toString();
                if (selectedOrderDatas.length > 0) {
                    let theQuery = `Select *
                                    from ${theTableName}
                                    where job5mfj.row_id in (${theRowIds});`;
                    Message.info('Please wait for the response. It may take a while');
                    let count: number = 11;
                    let interval = setInterval(() => {
                        count--;
                        loadingShow(true, 'Checking... ' + count + ' seconds');
                        if (count === 0) {
                            clearInterval(interval);
                            this.isAgentAlive = false;
                            Message.info('No response to procced. Please try again later.');
                            Message.error(
                                'Windows Agent is not currently available, please contact system administrator.'
                            );
                            loadingShow(false);
                        }
                        if (this.isAgentAlive) {
                            clearInterval(interval);
                            this.isAgentAlive = false;
                            loadingShow(false);
                        }
                    }, 1000);
                    SendRequest(theQuery, 'RESET DATA', undefined, true);
                } else {
                    Message.info('Select order');
                }
            }
        }

        if (args.item.id === 'sync_from_erp') {
            if (this.gantObj?.selectionModule.getSelectedRecords().length > 0) {
                let theTableName = await GetTablenameFromTask('ORDERS');
                if (theTableName === '') {
                    theTableName = 'job5mfj';
                } else {
                    theTableName = theTableName.trim();
                    let theValue = theTableName.split(' ');
                    theTableName = theValue[theValue.length - 1];
                }

                var selectedOrderDatas = this.gantObj.selectionModule
                    ?.getSelectedRecords()
                    .filter((orderandOp: any) => {
                        if (orderandOp.order_code != null) {
                            return orderandOp;
                        }
                    });
                if (selectedOrderDatas.length > 0) {
                    let theRowIds = selectedOrderDatas
                        .map((x: any) => x.pronto_row_id)
                        .toString();
                    let theQuery = `Select *
                                    from ${theTableName}
                                    where job5mfj.row_id in (${theRowIds});`;
                    Message.info('Please wait for the response. It may take a while');
                    let count: number = 11;
                    let interval = setInterval(() => {
                        count--;
                        loadingShow(true, 'Checking... ' + count + ' seconds');
                        if (count === 0) {
                            clearInterval(interval);
                            this.isAgentAlive = false;
                            Message.info('No response to procced. Please try again later.');
                            Message.error(
                                'Windows Agent is not currently available, please contact system administrator.'
                            );
                            loadingShow(false);
                        }
                        if (this.isAgentAlive) {
                            clearInterval(interval);
                            this.isAgentAlive = false;
                            loadingShow(false);
                        }
                    }, 1000);
                    SendRequest(theQuery, 'SYNCED', undefined, true);
                } else {
                    Message.error('Please select an order');
                }
            } else {
                Message.info('Select order');
            }
        }

        if (args.item.id === 'fetchRecords_from_erp') {
            this.setState({
                questionDialog: true,
            });
        }
        if (args.item.id === 'fetchRecords_from_pronto') {
            let result = await GetMaxProntoRowIdData();
            let maxProntoRowId;
            if (result.status === 200) {
                maxProntoRowId = result.data;
            }

            let theTableName = await GetTablenameFromTask('ORDERS');
            if (theTableName === '') {
                theTableName = 'job5mfj';
            } else {
                theTableName = theTableName.trim();
                let theValue = theTableName.split(' ');
                theTableName = theValue[theValue.length - 1];
            }
            // let theRowIds = gridCPWorkorder
            //   .getSelectedRecords()
            //   .map((x: any) => x.pronto_row_id)
            //   .toString();
            let theQuery = `Select *
                            from ${theTableName}
                            where job_type = 'J'
                              and row_id > (${maxProntoRowId});`;
            Message.info('Please wait for the response. It may take a while');
            let count: number = 11;
            let interval = setInterval(() => {
                count--;
                loadingShow(true, 'Checking... ' + count + ' seconds');
                if (count === 0) {
                    clearInterval(interval);
                    this.isAgentAlive = false;
                    Message.info('No response to procced. Please try again later.');
                    Message.error(
                        'Windows Agent is not currently available, please contact system administrator.'
                    );
                    loadingShow(false);
                }
                if (this.isAgentAlive) {
                    clearInterval(interval);
                    this.isAgentAlive = false;
                    loadingShow(false);
                }
            }, 1000);
            SendRequest(theQuery, 'SYNCED_NEW_RECORDS', undefined, true);
        }
        if (args.item.id === 'super_schedule') {
            let theDatas = this.gantObj.selectionModule?.getSelectedRecords() as any;
            if (theDatas.length > 0) {
                var hasOrder = false;
                var hasOperation = false;
                theDatas.map((eachData: any) => {
                    if (eachData.taskData.order_code) {
                        hasOrder = true;
                    }
                    if (eachData.taskData.operationId) {
                        hasOperation = true;
                    }
                });

                if (hasOperation && hasOrder) {
                    Message.error(
                        'You can not select both order and operation at the same time'
                    );
                    return;
                }
                if (hasOperation) {
                    this.setState({ isEditingOrder: false, massiveEditDialog: true });
                }
                if (hasOrder) {
                    this.setState({ isEditingOrder: true, massiveEditDialog: true });
                }
            }
        }
    }

    private selectedChildList: Array<any> = [];
    rowSelected = (args: any) => {
        if (args?.data.TaskID) {
            if (args?.data?.childRecords.length > 0) {
                args?.data?.childRecords?.map((child: any) => {
                    if (child.hasChildRecords != true) this.selectedChildList.push(child);
                });
                //this.selectedChildList = this.selectedChildList.filter(child => child !=args?.data);
            } else {
                if (args?.data.hasChildRecords != true)
                    this.selectedChildList.push(args?.data);
            }
            this.selectedChildList = this.selectedChildList.filter(
                (child) => !Array.isArray(child)
            );
        } else {
            args?.data?.map((child: any) => {
                if (child.hasChildRecords != true && child.pronto_row_id === null) {
                    this.selectedChildList.push(child);
                }
                this.selectedChildList = this.selectedChildList.filter(
                    (child) => !Array.isArray(child)
                );
            });
        }
        this.selectedChildList = this.selectedChildList
            .filter((child) => !Array.isArray(child))
            .filter(
                (child, index, self) =>
                    index ===
                    self.findIndex((c) => JSON.stringify(c) === JSON.stringify(child))
            );
        // this.setState({ selectedRecords: [...this.state.selectedRecords, args.data] });
        // this.selectedChildList = this.state.selectedRecords;
    };
    rowDeselected = (args: any) => {
        if (args?.data.TaskID) {
            if (args?.data?.childRecords.length > 0) {
                args?.data?.childRecords?.map((child: any, index: any) => {
                    this.selectedChildList = this.selectedChildList.filter(
                        (item) => child.TaskID !== item.TaskID
                    );
                });
            } else {
                this.selectedChildList = this.selectedChildList.filter(
                    (child) => child != args?.data
                );
            }
        } else {
            args?.data?.map((child: any) => {
                this.selectedChildList = this.selectedChildList.filter(
                    (child) => !this.selectedChildList.includes(child)
                );
            });
        }
        // this.setState({
        //     selectedRecords: this.state.selectedRecords.filter(
        //         (item: any) => item.id !== args.data.id
        //     ),
        // });
        // this.selectedChildList = this.state.selectedRecords;

    };

    getSelectedChilds = (): Array<any> => {
        var theData = this.gantObj?.selectRows(this.selectedChildList) as any;
        let theAllChildsFromParent: Array<any> = [];
        //var theData = this.gantObj.selectionModule.getSelectedRecords() as any;
        theData?.map((theEl: any) => {
            if (!theEl.hasChildRecords) {
                theAllChildsFromParent.push(theEl);
            }
        });
        return theAllChildsFromParent;
    };
    reSchedulerGantt = async (
        isOneStepProcces: boolean,
        type?: string,
        date?: Date,
        isProgress?: boolean,
        progressValue?: number,
        setParentEffected?: boolean,
        updateRecords: boolean = true,
        isMultipleSchedule: boolean = false,
        isTaskbarEditing: string = '',
    ) => {
        this.allowToFire = false;
        let dataChilds = this.selectedChildList;
        let datasToSend: Array<any> = [];

        dataChilds.map((theChild, index) => {
            //if (index === dataChilds.length - 1) {
            if (true) {
                this.allowToFire = true;
            }
            this.allowToFire = true;

            var theSelectedData = this.gantObj?.flatData[theChild.index] as any;
            if (isProgress) {
                theSelectedData.Progress = progressValue;
            } else {
                if (isOneStepProcces) {
                    if (type === 'next') {
                        let theCurrentDate = new Date(theSelectedData.StartDate);
                        theCurrentDate.setDate(
                            theCurrentDate.getDate() + Number(this.offset)
                        );

                        theSelectedData.StartDate = moment(theCurrentDate)
                            .subtract(moment().utcOffset(), 'minutes')
                            .toISOString();
                    } else if (type === 'previous') {
                        let theCurrentDate = new Date(theSelectedData.StartDate);
                        theCurrentDate.setDate(
                            theCurrentDate.getDate() - Number(this.offset)
                        );
                        theSelectedData.StartDate = moment(theCurrentDate)
                            .subtract(moment().utcOffset(), 'minutes')
                            .toISOString();
                    }
                } else {
                    if (theSelectedData) {
                        //theSelectedData.StartDate = date;
                        const timePart = moment(theSelectedData.StartDate).format('HH:mm:ss');

                        if (typeof date === 'string' && !(date as string).includes(':')) {
                            let dateNew = moment(`${date}T${timePart}`);
                            theSelectedData.StartDate = moment(dateNew)
                                .subtract(moment().utcOffset(), 'minutes')
                                .toISOString();
                        }
                        else {
                            theSelectedData.StartDate = moment(date)
                                .subtract(moment().utcOffset(), 'minutes')
                                .toISOString();
                        }
                    }
                }
            }
            theSelectedData.isEffected = true;
            if (setParentEffected) {
                if (theSelectedData.parentItem?.uniqueID) {
                    var parent = this.gantObj?.flatData.find(
                        (el) => el.uniqueID === theSelectedData.parentItem?.uniqueID
                    ) as any;
                    if (parent) {
                        parent.isEffected = true;
                    }
                }
            }
            this.modifiedDatas.push(theSelectedData);
        });
        await this.EditOperationAndOrderDatas(isMultipleSchedule, isTaskbarEditing);
        this.setState({ hideSchedulerTimeDialog: false, hidePercentage: false });
    };

    editPlans(obj: any) {
        EditPlan(obj)
            .then((res: any) => {
                if (this.props.current_plan_data.isLocked) {
                    Message.warning(
                        `${this.props.current_plan_data.plan_name} has been locked down`
                    );
                    this.gantObj.editSettings = {
                        allowAdding: false,
                        allowEditing: false,
                        allowDeleting: false,
                        mode: 'Auto',
                        showDeleteConfirmDialog: false,
                    };
                } else {
                    Message.success(
                        `${this.props.current_plan_data.plan_name} has been unlock`
                    );
                    this.gantObj.editSettings = this.editSettings;
                }
                loadingShow(false);
                this.setState({
                    current_plan_isLocked: this.props.current_plan_data.isLocked,
                });
            })
            .catch((err: any) => {
                if (err.response) {
                    Message.error(
                        err.response.data +
                        '\n' +
                        err.response.status +
                        '\n' +
                        err.response.headers
                    );
                } else if (err.request) {
                    Message.error(err.request);
                } else {
                    Message.error('Error: ' + err.message);
                }
                loadingShow(false);
            });
    }

    getShiftElments() {
        if (!this.isMountedCS) return;
        GetRosters().then((res) => {
            const incomingData = Array.isArray(res?.data) ? res.data : [];

            let filterData = incomingData.filter((x: any) => x.rosterType === 'Shift');
            filterData.unshift({ rosterCode: '', rosterId: -1, description: '' });

            if (this.isMountedCS) {
                this.setState({ ShiftElementData: filterData });
            }
        })
    }

    dataBound = () => {
        // @ts-ignore
    };

    setHidePlanOrder = (val: boolean) => {
        this.setState({ hideDialogOrder: val });
    };

    FilterPrio = () => {
        this.buildQuery();
    };
    clearFilter = () => {
        this.departmentFMSCom.value = [];
        this.sectionFMSCom.value = [];
        this.prontoReferenceFMSCom.value = [];
        this.holdReasonFMSCom.value = [];
        this.workorderCodeFMSCom.value = '';
        this.statusFMSCom.value = [];
        this.referenceFMSCom.value = '';
        this.assetFMSCom.value = '';
        this.typeFMSCom.value = [];
        this.hasProblem.value = [];
        this.respFMSCom.value = [];
        this.priorityFMSCom.value = [];
        this.ScheduleNumberFMSCom.value = '';
        if (this.startDateFMSCom) {
            this.startDateFMSCom.value = '';
        }
        this.schdeduleStartDateVal = '';
        this.ScheduleNumberFMSComValue = '';
        chips.selectedChips = [];
        this.priorityFMSComValue = [];
        this.statusFMSComValue = [];
        this.departmentFMSComValue = [];
        this.hasProblemValue = [];
        this.typeFMSComValue = [];
        this.respFMSComValue = [];

        // referenceFMSComValue = '';
        this.setState({ referenceFMSComValue: '' });
        this.workorderCodeFMSComValue = '';

        if (this.current_query != '') {
            this.checkFilterParams = false;
            this.buildQuery();
        }
    };
    PriorityMultiSelect = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        this.priorityFMSCom = scope;
                    }}
                    field={{ value: 'value', text: 'alias' }}
                    id='ordersFilterMultiPriority'
                    url='global-filter?where=workorders$priority$isEnabled€1'
                    placeHolder='Select a Priority'
                    value={this.priorityFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectordersFilterMultiPriority',
                                '{"value":[]}'
                            );
                        }
                        this.priorityFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    WorkOrderCodeInput = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            this.workorderCodeFMSCom = scope;
                        }}
                        autocomplete='off'
                        enablePersistence={true}
                        showClearButton
                        id='WorkOrderTextBox'
                        placeholder='Work Order'
                        value={this.workorderCodeFMSComValue}
                        onChange={(args: any) => {
                            this.workorderCodeFMSComValue = args.target.value;
                        }}
                    />
                )}
            </div>
        );
    };
    ScheduleNumberComponent = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            this.ScheduleNumberFMSCom = scope;
                        }}
                        autocomplete='off'
                        id='PMSchedulerNumberTextComponent'
                        showClearButton
                        placeholder='PM Schedule Number'
                        value={this.ScheduleNumberFMSComValue}
                        enablePersistence={true}
                        onChange={(args: any) => {
                            this.ScheduleNumberFMSComValue = args.target.value;
                        }}
                    />
                )}
            </div>
        );
    };
    SectionFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            this.sectionFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='SectionordersFilterMulti'
                        url='global-filter?where=workorders$section$isEnabled€1&='
                        placeHolder='Select a Section'
                        value={this.sectionFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectSectionordersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            this.sectionFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    PontoReferenceFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            this.prontoReferenceFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='ProntoReferenceOrdersFilterMulti'
                        url='global-filter?where=workorders$reference$isEnabled€1&='
                        placeHolder='Select a Reference'
                        value={this.prontoReferenceFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectProntoReferenceOrdersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            this.prontoReferenceFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    HoldReasonFilterInput = () => {
        return (
            <div>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope: MultiSelectC) => {
                            this.holdReasonFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='reasonOrdersFilterMulti'
                        url='global-filter?where=workorders$reason$isEnabled€1&='
                        placeHolder='Select a Hold Reason'
                        value={this.holdReasonFMSComValue}
                        onChange={(e: any) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectreasonOrdersFilterMulti',
                                    '{"value":[]}'
                                );
                            }
                            this.holdReasonFMSComValue = e.value;
                        }}
                        enablePersistence={true}
                    />
                )}
            </div>
        );
    };
    ReferenceInput = () => {
        return (
            <div>
                {ERP_TYPE === erpTypeName && (
                    <TextBoxComponent
                        enablePersistence={true}
                        type={'text'}
                        ref={(scope: TextBoxComponent) => {
                            this.referenceFMSCom = scope;
                        }}
                        autocomplete='off'
                        showClearButton
                        placeholder='Reference'
                        id='ReferenceTextBox'
                        value={this.state.referenceFMSComValue}
                        onChange={(args: any) => {
                            // referenceFMSComValue = args.target.value;
                            this.setState({ referenceFMSComValue: args.target.value });
                        }}
                    />
                )}
            </div>
        );
    };
    AssetInput = () => {
        return (
            <div>
                <TextBoxComponent
                    type={'text'}
                    ref={(scope: TextBoxComponent) => {
                        this.assetFMSCom = scope;
                    }}
                    autocomplete='off'
                    showClearButton
                    placeholder='Asset'
                    id='AssetTextBox'
                    enablePersistence={true}
                    value={this.assetFMSComValue}
                    onChange={(args: any) => {
                        if (args.target.value == '') {
                            localStorage.setItem('textboxAssetTextBox', '{"value":""}');
                        }

                        this.assetFMSComValue = args.target.value;
                    }}
                />
            </div>
        );
    };
    TypeInput = () => {
        return (
            <>
                <GlobalMultiSelection
                    refDD={(scope: MultiSelectC) => {
                        this.typeFMSCom = scope;
                    }}
                    //field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                    field={
                        erpTypeName === ERP_TYPE
                            ? { value: 'value', text: 'description' }
                            : { value: 'value', text: 'alias' }
                    }
                    id='operationFilterMultiType'
                    //url='system-config?where=P3'
                    url={'global-filter?where=workorders$type$isEnabled€1'}
                    placeHolder='Select a Type'
                    value={this.typeFMSComValue}
                    onChange={(e: any) => {
                        if (e.value.length == 0) {
                            localStorage.setItem(
                                'multiselectoperationFilterMultiType',
                                '{"value":[]}'
                            );
                        }

                        this.typeFMSComValue = e.value;
                    }}
                    enablePersistence={true}
                />
            </>
        );
    };
    //global-filter?where=workorders$type$isEnabled€1
    RespInput = () => {
        return (
            <>
                {ERP_TYPE !== erpTypeName && (
                    <GlobalMultiSelection
                        refDD={(scope) => {
                            this.respFMSCom = scope;
                        }}
                        field={{ value: 'value', text: 'alias' }}
                        id='ordersFilterMultiResp'
                        //url='system-config?where=P2'
                        url='global-filter?where=workorders$responsibility$isEnabled€1'
                        placeHolder='Select a Resp'
                        onChange={(e) => {
                            if (e.value.length == 0) {
                                localStorage.setItem(
                                    'multiselectordersFilterMultiResp',
                                    '{"value":[]}'
                                );
                            }
                            this.respFMSComValue = e.value;
                        }}
                        value={this.respFMSComValue}
                        enablePersistence={true}
                    />
                )}
            </>
        );
    };

    ScheduleStartDateInput = () => {
        return (
            <div>
                <DateRangePickerComponent
                    placeholder='Planned Start Date'
                    id='ScheduleStartDateFilter'
                    ref={(a) => {
                        this.startDateFMSCom = a;
                    }}
                    enablePersistence={true}
                    enabled={true}
                    format={'dd/MM/yyyy'}
                    showClearButton={true}
                    value={this.schdeduleStartDateVal}
                    onChange={(e: any) => {
                        if (e.value == null) {
                            localStorage.setItem(
                                'daterangepickerScheduleStartDateFilter',
                                '{"startDate":null,"endDate":null,"value":""}'
                            );
                        }

                        this.schdeduleStartDateVal = e.value;
                    }}
                ></DateRangePickerComponent>
            </div>
        );
    };

    render() {
        //const toolbarOptions = this.props.isSuperVisor ? this.toolbarAdmin : this.toolbar;
        const toolbarOptions: (string | ItemModel)[] = [
            {
                text: 'Commit',
                tooltipText: 'Commit to Pronto Database',
                prefixIcon: 'e-check',
                id: 'commit',
            },
            {
                text: 'Schedule',
                tooltipText: 'Scheduler',
                prefixIcon: 'e-timeline-month',
                id: 'scheduler',
            },

            {
                text: 'Assign Workorders',
                tooltipText: 'Assign workorders into the plan.',
                prefixIcon: 'e-properties-1',
                id: 'assign_workorders',
            },
            {
                text: 'Previous Day',
                tooltipText: 'Rescheduled it for one day.',
                prefixIcon: 'e-chevron-left',
                id: 'previous',
            },
            {
                text: 'Day',
                tooltipText: 'Set Offset.',
                id: 'a',
                width: 30,
                template: this.temp.bind(this),
            },
            {
                text: 'Next Day',
                tooltipText: 'Rescheduled it for one day.',
                prefixIcon: 'e-chevron-right',
                id: 'next',
            },
            'Edit',
            'Update',
            {
                text: 'Assign Shift',
                tooltipText: 'Assign Shift',
                prefixIcon: 'e-day',
                id: 'assignshift',
            },
            {
                text: 'Assign Team',
                tooltipText: 'Assign Team',
                prefixIcon: 'e-people',
                id: 'assignteam',
            },
            {
                text: 'Super Scheduler',
                tooltipText: 'Super Scheduler',
                id: 'super_schedule',
            },
            {
                text: 'Sync From ERP',
                tooltipText: '',
                id: 'sync_from_erp',
                visible: ERP_TYPE === erpTypeName ? false : true,
            },
            {
                text: 'Reset Data',
                tooltipText: '',
                id: 'reset_pronto_data',
                visible: ERP_TYPE === erpTypeName ? false : true,
            },
            // {
            //   text: 'Get New Data',
            //   tooltipText: '',
            //   id: 'fetchRecords_from_erp',
            //   visible: ERP_TYPE === erpTypeName ? true : false,
            // },
            {
                text: 'Get New Data',
                tooltipText: '',
                id: 'fetchRecords_from_pronto',
                visible: ERP_TYPE === erpTypeName ? false : true,
            },
            {
                text: 'Refresh',
                tooltipText: 'Refresh',
                prefixIcon: 'e-repeat',
                id: 'refresh',
            },
            'Cancel',
            {
                text: 'Expand/Collapse',
                id: 'expand_collapse',
                template: this.expandeCollapse.bind(this),
            },
            {
                text: 'Zoom To Fit',
                id: 'zoom_to_fit',
                template: this.zoomSettings.bind(this),
            },
            'ZoomToFit',
            'Search',
            'PrevTimeSpan',
            'NextTimeSpan',
            // 'Outdent',
            // 'Indent',

            {
                text: 'Exports',
                id: 'exports',
                template: this.exports.bind(this),
            },
            'CriticalPath',
            {
                text: 'Group',
                id: 'group',
                template: this.dropdownTemplate.bind(this),
            },
        ];

        return (
            <div>
                <div
                    className='header-cloud-scheduler-fixed'
                    style={{
                        marginRight: 30,
                        marginTop: this.props.isSuperVisor ? 22 : 0,
                    }}
                >
                    {/*<button*/}
                    {/*    style={{*/}
                    {/*        height: '40px',*/}
                    {/*        backgroundColor: 'transparent',*/}
                    {/*        border: 'none',*/}
                    {/*        zIndex: 1000,*/}
                    {/*    }}*/}
                    {/*    onClick={() => {*/}
                    {/*        this.sidebarobj?.toggle();*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    {this.state.isSidebarOpen ? (*/}
                    {/*        <BsChevronCompactRight/>*/}
                    {/*    ) : (*/}
                    {/*        <BsChevronCompactLeft/>*/}
                    {/*    )}*/}
                    {/*</button>*/}
                    {/*<FcSettings*/}
                    {/*    size={30}*/}
                    {/*    style={{marginRight: 5}}*/}
                    {/*    onClick={() => {*/}
                    {/*        this.setState({settingsDialog: true});*/}
                    {/*    }}*/}
                    {/*/>*/}

                    {true && this.props.isSuperVisor ? (
                        <button
                            style={{
                                marginRight: '5px',
                                marginLeft: 5,
                                width: '70px',
                                height: '35px',
                            }}
                            className='btn btn-primary p-3 rounded-xl'
                            id='cloudSchedulerSavePoint'
                            onClick={this.onLocked.bind(this)}
                        >
                            {this.state.current_plan_isLocked ? (
                                <AiFillUnlock size={15} />
                            ) : (
                                <AiFillLock size={15} />
                            )}
                            {this.state.current_plan_isLocked ? 'UnLock' : 'Lock'}
                        </button>
                    ) : null}
                </div>
                <SidebarKPI
                    sidebarOpen={(val: boolean) => this.setState({ isSidebarOpen: val })}
                    refSide={(ref: SidebarComponent) => (this.sidebarobj = ref)}
                    query={this.state.query}
                />
                <div id='cloud-scheduler-main-content'>
                    <div className='control-pane' style={{ height: '100vh' }}>
                        <div className='control-section'>
                            <div
                                style={{
                                    width: '250px',
                                    position: 'absolute',
                                    top: '-25px',
                                    left: '968px',
                                    justifyContent: 'flex-end',
                                    display: 'flex',
                                    gap: '5px',
                                }}
                            />
                            <div>
                                <GanttComponent
                                    enablePredecessorValidation={false}
                                    id='cloud-scheduler-gantt'
                                    dataSource={this.state.GantData}
                                    ref={(gant: GanttComponent) => (this.gantObj = gant)}
                                    expanded={this.expanded.bind(this)}
                                    collapsed={this.collapsed.bind(this)}
                                    dateFormat='dd/MM/yyyy HH:mm'
                                    durationUnit='Hour'
                                    actionComplete={this.actionCompletedElement.bind(this)}
                                    actionBegin={this.actionBegin.bind(this)}
                                    dataBound={this.dataBound.bind(this)}
                                    treeColumnIndex={5}
                                    contextMenuItems={this.contextMenuItems}
                                    contextMenuOpen={this.contextMenuOpen.bind(this)}
                                    rowHeight={32}
                                    contextMenuClick={this.contextMenuClick.bind(this)}
                                    showColumnMenu={true}
                                    collapseAllParentTasks={true}
                                    taskType='FixedWork'
                                    width={'100%'}
                                    taskbarEditing={this.taskbarEditing.bind(this)}
                                    enableTimelineVirtualization={true}
                                    allowFiltering={true}
                                    selectionSettings={{
                                        type: 'Multiple',
                                        mode: 'Row',
                                        enableToggle: true,
                                    }}
                                    allowSorting={true}
                                    connectorLineBackground='red'
                                    allowResizing={true}
                                    workWeek={[
                                        'Monday',
                                        'Tuesday',
                                        'Wednesday',
                                        'Thursday',
                                        'Friday',
                                        'Saturday',
                                        'Sunday',
                                    ]}
                                    toolbarClick={this.toolbarClick.bind(this)}
                                    editDialogFields={this.editDialogFields}
                                    projectStartDate={moment.utc(this.state.projectStartDate).add(11).format('YYYY-MM-DD HH:mm:ss')}
                                    projectEndDate={moment.utc(this.state.projectEndDate).add(11).format('YYYY-MM-DD HH:mm:ss')}
                                    allowRowDragAndDrop={false}
                                    queryCellInfo={this.gantCellQuery.bind(this)}
                                    rowSelected={this.rowSelected}
                                    rowDeselected={this.rowDeselected}
                                    taskFields={{
                                        id: 'TaskID',
                                        name: 'TaskName',
                                        startDate: 'StartDate',
                                        endDate: 'EndDate',
                                        duration: 'Duration',
                                        progress: 'Progress',
                                        dependency: 'Predecessor',
                                        child: 'subtasks',
                                        notes: 'info',
                                        resourceInfo: 'Resources',
                                        segments: 'Segments',
                                        work: 'Work',
                                    }}
                                    timelineSettings={this.timelineSettings}
                                    labelSettings={
                                        this.state.displayGantInformation
                                            ? this.labelSettings
                                            : undefined
                                    }
                                    editSettings={
                                        this.state.current_plan_isLocked
                                            ? undefined
                                            : this.editSettings
                                    }
                                    height={
                                        this.context.expandStatus
                                            ? 'calc(-130px + 70vh)'
                                            : 'calc(-130px + 95vh)'
                                    }
                                    gridLines={'Both'}
                                    toolbar={toolbarOptions}
                                    resourceFields={this.resourceFields}
                                    resources={this.state.resourceData}
                                    enableContextMenu={true}
                                    filterSettings={{ type: 'Menu' }}
                                    allowExcelExport={true}
                                    excelQueryCellInfo={this.excelQueryCellInfo.bind(this)}
                                    //beforeExcelExport={this.handleExcelExport.bind(this)}
                                    allowPdfExport={true}
                                    allowReordering={true}
                                    highlightWeekends={true}
                                    enableVirtualization={false}
                                    splitterSettings={{
                                        columnIndex: 2,
                                        position: '60%',
                                    }}
                                    dayWorkingTime={this.state.dayWorkingTime}
                                    beforePdfExport={this.beforePdfExport.bind(this)}
                                    timezone={'UTC'}
                                //loadChildOnDemand={true}
                                >
                                    <ColumnsDirective>
                                        {this.changesAppliedColumns.map((el: any) => {
                                            return (
                                                <ColumnDirective
                                                    key={el.field}
                                                    field={el.field}
                                                    headerText={el.headerText}
                                                    width={el.width}
                                                    visible={el.visible}
                                                    editType={el.editType}
                                                    edit={el.edit}
                                                    type={el.type}
                                                    format={el.format}
                                                    allowEditing={el.allowEditing}
                                                    displayAsCheckBox={el.displayAsCheckBox}
                                                    template={el.template}
                                                />
                                            );
                                        })}
                                    </ColumnsDirective>
                                    <EditDialogFieldsDirective>
                                        {editDialogFields.map((el) => {
                                            return (
                                                <EditDialogFieldDirective
                                                    key={el.type}
                                                    type={el.type as any}
                                                    headerText={el.headerText}
                                                />
                                            );
                                        })}
                                    </EditDialogFieldsDirective>
                                    <Inject
                                        services={[
                                            Edit,
                                            Selection,
                                            Toolbar,
                                            DayMarkers,
                                            CriticalPath,
                                            Resize,
                                            ColumnChooser,
                                            Filter,
                                            ContextMenu,
                                            ColumnMenu,
                                            VirtualScroll,
                                            ExcelExport,
                                            PdfExport,
                                            Sort,
                                            Reorder,
                                        ]}
                                    />
                                </GanttComponent>
                                <TooltipComponent
                                    target=".order-code-cell"
                                    position="TopCenter"
                                    opensOn="Hover"
                                    showTipPointer={true}
                                    cssClass="custom-syncfusion-tooltip"
                                />
                            </div>
                        </div>
                    </div>
                    {this.state.hideDeleteDialog ? (
                        <GlobalDialog
                            showDialog={this.state.hideDeleteDialog}
                            setShowDialog={(val) => this.setState({ hideDeleteDialog: val })}
                            header='Confirm Shift Assign'
                            width={'222px'}
                            hideDoneButton={true}
                            buttons={this.buttonShiftAssignment}
                        >
                            <>
                                <DropDownListComponent
                                    dataSource={this.state.ShiftElementData}
                                    placeholder='Shift'
                                    fields={{ text: 'rosterCode', value: 'rosterId' }}
                                    ref={(scope: DropDownListComponent) =>
                                        (this.dropDownListObjectShiftElment = scope)
                                    }
                                    itemTemplate={
                                        (this.itemTemplateShiftColor =
                                            this.itemTemplateShiftColor.bind(this))
                                    }
                                />
                            </>
                        </GlobalDialog>
                    ) : null}
                    {this.state.questionDialog ? (
                        <GlobalDialog
                            showDialog={this.state.questionDialog}
                            setShowDialog={(val) => {
                                this.setState({
                                    questionDialog: true,
                                });
                            }}
                            header='Fetch Records Message'
                            width={'20%'}
                            height={'15%'}
                            hideDoneButton={true}
                            content={'Which datas do you want to fetch?'}
                            buttons={this.buttonsOrder}
                        ></GlobalDialog>
                    ) : null}

                    {this.state.hideAssignTeamDialog ? (
                        <GlobalDialog
                            showDialog={this.state.hideAssignTeamDialog}
                            setShowDialog={(val) =>
                                this.setState({ hideAssignTeamDialog: val })
                            }
                            header='Confirm Team Assign'
                            width={'270px'}
                            hideDoneButton={true}
                            buttons={this.buttonTeamAssignment}
                        >
                            <div>
                                <GlobalDropDown
                                    id='cloudscheduler-team'
                                    placeHolder='Select a team'
                                    key='cloudscheduler-team-key'
                                    field={{ value: 'team_id', text: 'team_code' }}
                                    refDD={(scope: DropDownListComponent) =>
                                        (this.assignTeamDropDown = scope)
                                    }
                                    url='team'
                                    value={this.assignTeamText}
                                    floatLabelType='Never'
                                />
                            </div>
                        </GlobalDialog>
                    ) : null}
                    {this.state.hidePercentage ? (
                        <GlobalDialog
                            showDialog={this.state.hidePercentage}
                            setShowDialog={(val) => this.setState({ hidePercentage: val })}
                            header='Confirm Percentage'
                            width={'222px'}
                            hideDoneButton={true}
                            buttons={this.buttonPercentage}
                        >
                            <div>
                                <NumericTextBoxComponent
                                    ref={(el: NumericTextBoxComponent) => (this.percentage = el)}
                                    format='n'
                                    value={0}
                                    min={0}
                                    max={100}
                                />
                            </div>
                        </GlobalDialog>
                    ) : null}
                    {this.state.hideSchedulerTimeDialog ? (
                        <GlobalDialog
                            showDialog={this.state.hideSchedulerTimeDialog}
                            setShowDialog={(val) =>
                                this.setState({ hideSchedulerTimeDialog: val })
                            }
                            header='Confirm Scheduler'
                            width={'350px'}
                            hideDoneButton={true}
                            buttons={this.buttonScheduler}
                        >
                            <DateTimePickerComponent
                                placeholder='Select a range'
                                change={this.confirmSchedulerTime.bind(this)}
                                format={'dd/MM/yyyy HH:mm'}
                                value={this.state.defaultConfirmScheduleDate}
                                ref={(scope: DateTimePickerComponent) =>
                                    (this.dateTimePicker = scope)
                                }
                            />
                        </GlobalDialog>
                    ) : null}
                    {this.state.massiveEditDialog ? (
                        <MassiveOrderEdit
                            isEditingOrder={this.state.isEditingOrder}
                            title='Schedule Edit'
                            callback={this.massCallBack}
                            massiveEditDialog={this.state.massiveEditDialog}
                            setMassiveEditDialog={(val: boolean) => {
                                this.setState({ massiveEditDialog: val });
                            }}
                        />
                    ) : null}

                    {this.state.settingsDialog ? (
                        <GlobalDialog
                            showDialog={this.state.settingsDialog}
                            setShowDialog={(val) => this.setState({ settingsDialog: val })}
                            header='Gantt Settings'
                            width={'500px'}
                            hideDoneButton={false}
                            content={() => {
                                return (
                                    <GanttSettings
                                        allowDragDrop={this.state.allowDragDrop}
                                        setAllowDragDrop={(val) =>
                                            this.setState({ allowDragDrop: val })
                                        }
                                        allowSeg={this.state.allowSeg}
                                        gantObj={this.gantObj}
                                        dayWorkingTime={this.state.dayWorkingTime}
                                        setAllowSeg={(val) => this.setState({ allowSeg: val })}
                                        setDayWorkingTime={(val) =>
                                            this.setState({ dayWorkingTime: val })
                                        }
                                    />
                                );
                            }}
                        ></GlobalDialog>
                    ) : null}
                    <GlobalSearch
                        id={'cloud-planner-orders-filter'}
                        height={process.env.REACT_APP_ERP_TYPE == 'MEX' ? '460px' : '500px'}
                        applyFilter={this.FilterPrio.bind(this)}
                        clearFilter={this.clearFilter.bind(this)}
                        Component1={this.PriorityMultiSelect.bind(this)}
                        Component2={this.AssetInput.bind(this)}
                        Component3={this.TypeInput.bind(this)}
                        Component4={this.RespInput.bind(this)}
                        Component5={this.ScheduleNumberComponent.bind(this)}
                        Component6={this.ReferenceInput.bind(this)}
                        Component7={this.WorkOrderCodeInput.bind(this)}
                        Component8={this.SectionFilterInput.bind(this)}
                        Component9={this.PontoReferenceFilterInput.bind(this)}
                        Component10={this.ScheduleStartDateInput.bind(this)}
                        Component11={this.HoldReasonFilterInput.bind(this)}
                    />
                    {this.state.currentDialogSettings.show ? (
                        <DialogComponent
                            isModal={true}
                            id='defaultDialogAddTrades'
                            showCloseIcon={true}
                            visible={this.state.currentDialogSettings.show}
                            width={this.state.currentDialogSettings.width}
                            height={this.state.currentDialogSettings.height}
                            header='Confirm'
                            buttons={[
                                {
                                    click: () => {
                                        if (this.state.currentDialogSettings.type === 'exeption') {
                                            this.approveSendBack();
                                        } else if (
                                            this.state.currentDialogSettings.type === 'done'
                                        ) {
                                            this.setProgressGanttRecords();
                                        } else {
                                            this.applyConfirm();
                                        }
                                    },
                                    buttonModel: {
                                        content: this.state.currentDialogSettings.firstButtonText,
                                        isPrimary: true,
                                    },
                                },
                                {
                                    click: () => {
                                        this.setState({
                                            currentDialogSettings: {
                                                ...this.state.currentDialogSettings,
                                                show: false,
                                            },
                                        });
                                    },
                                    buttonModel: {
                                        content: this.state.currentDialogSettings.seccondButtonText,
                                    },
                                },
                            ]}
                            close={() => {
                                this.setState({
                                    currentDialogSettings: {
                                        ...this.state.currentDialogSettings,
                                        show: false,
                                    },
                                });
                            }}
                            content={this.state.currentDialogSettings.content}
                        ></DialogComponent>
                    ) : null}
                </div>
                {this.state.hideDialogOrder ? (
                    <GlobalPlannedOrderGrid
                        hideDialogOrder={this.state.hideDialogOrder}
                        setHideDialogOrder={this.setHidePlanOrder}
                        getPlanOrder={this.buildQuery.bind(this)}
                        plan_id={this.props.current_plan_id}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    largeMode: state.search.largeMode,
    storeTeam: state.search.storeTeam,
    defaultTeams: state.search.defaultTeams,
    defaultAssignments: state.search.defaultAssignments,
    refreshTeamComponent: state.search.refreshTeamComponent,
    defaultPairTrades: state.search.defaultPairTrades,
    planId: state.search.planId,
    timezone_offset: state.search.timezone_offset,
    page_range_from_settings: state.search.page_range_from_settings,
    weekStartDay: state.search.weekStartDay,
    isOpPlanSelected: state.search.isOpPlanSelected,
});

const mapDispatchToProps = {
    setRefreshTeamComponent,
    setStoreTeam,
    setTrades,
    setAssignments,
    setTeamDataChanged,
    setDefaultTeams,
    setDefaultPairTrades,
    setSearchCaseOrder,
    setIsPlanSelected,
    setCloudSchedularGantDataChanged,
    setCloudSchedulerFilterTeamDropdownValueChanged,
};
const ConnectedCloudScheduler = connect(
    mapStateToProps,
    mapDispatchToProps
)(CloudScheduler);

function withMyHook(Component: any) {
    return function WrappedComponent(props: any) {
        const dispatch = useDispatch();
        return <Component {...props} dispatch={dispatch} />;
    };
}
export default withMyHook(ConnectedCloudScheduler);
